/* tslint:disable */
/* eslint-disable */
/**
 * Leo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.7.411
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface APIHandlerMetadataWithContent
 */
export interface APIHandlerMetadataWithContent {
    /**
     * 
     * @type {any}
     * @memberof APIHandlerMetadataWithContent
     */
    'api_name'?: any;
    /**
     * 
     * @type {any}
     * @memberof APIHandlerMetadataWithContent
     */
    'llm_hint'?: any;
    /**
     * 
     * @type {any}
     * @memberof APIHandlerMetadataWithContent
     */
    'is_address_required'?: any;
    /**
     * 
     * @type {any}
     * @memberof APIHandlerMetadataWithContent
     */
    'is_state_required'?: any;
    /**
     * 
     * @type {any}
     * @memberof APIHandlerMetadataWithContent
     */
    'email'?: any;
    /**
     * 
     * @type {any}
     * @memberof APIHandlerMetadataWithContent
     */
    'phone'?: any;
    /**
     * 
     * @type {any}
     * @memberof APIHandlerMetadataWithContent
     */
    'mortgage_lead_name'?: any;
    /**
     * 
     * @type {any}
     * @memberof APIHandlerMetadataWithContent
     */
    'loan_advisor_name'?: any;
    /**
     * 
     * @type {any}
     * @memberof APIHandlerMetadataWithContent
     */
    'loan_advisor_id'?: any;
    /**
     * 
     * @type {any}
     * @memberof APIHandlerMetadataWithContent
     */
    'boolean_response'?: any;
    /**
     * 
     * @type {any}
     * @memberof APIHandlerMetadataWithContent
     */
    'transaction_id'?: any;
    /**
     * 
     * @type {any}
     * @memberof APIHandlerMetadataWithContent
     */
    'states'?: any;
    /**
     * 
     * @type {any}
     * @memberof APIHandlerMetadataWithContent
     */
    'subtask'?: any;
    /**
     * 
     * @type {any}
     * @memberof APIHandlerMetadataWithContent
     */
    'failed_retries'?: any;
    /**
     * 
     * @type {any}
     * @memberof APIHandlerMetadataWithContent
     */
    'question'?: any;
    /**
     * 
     * @type {any}
     * @memberof APIHandlerMetadataWithContent
     */
    'status'?: any;
    /**
     * 
     * @type {any}
     * @memberof APIHandlerMetadataWithContent
     */
    'bypass_llm'?: any;
    /**
     * 
     * @type {any}
     * @memberof APIHandlerMetadataWithContent
     */
    'score'?: any;
    /**
     * 
     * @type {any}
     * @memberof APIHandlerMetadataWithContent
     */
    'id'?: any;
    /**
     * 
     * @type {any}
     * @memberof APIHandlerMetadataWithContent
     */
    'content'?: any;
}
/**
 * 
 * @export
 * @interface APIRetrieverFunction
 */
export interface APIRetrieverFunction {
}
/**
 * 
 * @export
 * @interface ActionType
 */
export interface ActionType {
}
/**
 * 
 * @export
 * @interface ApiSource
 */
export interface ApiSource {
    /**
     * 
     * @type {any}
     * @memberof ApiSource
     */
    'id'?: any;
    /**
     * 
     * @type {any}
     * @memberof ApiSource
     */
    'api_name'?: any;
    /**
     * 
     * @type {any}
     * @memberof ApiSource
     */
    'question'?: any;
    /**
     * 
     * @type {any}
     * @memberof ApiSource
     */
    'content'?: any;
}
/**
 * 
 * @export
 * @interface BodyChatGenerateStreamChatGenerateStreamGet
 */
export interface BodyChatGenerateStreamChatGenerateStreamGet {
    /**
     * 
     * @type {any}
     * @memberof BodyChatGenerateStreamChatGenerateStreamGet
     */
    'follow_ups'?: any;
    /**
     * 
     * @type {any}
     * @memberof BodyChatGenerateStreamChatGenerateStreamGet
     */
    'helper_prompt'?: any;
    /**
     * 
     * @type {any}
     * @memberof BodyChatGenerateStreamChatGenerateStreamGet
     */
    'rezen_objects'?: any;
}
/**
 * 
 * @export
 * @interface BulkUpdateRequest
 */
export interface BulkUpdateRequest {
    /**
     * 
     * @type {any}
     * @memberof BulkUpdateRequest
     */
    'pair_ids': any;
    /**
     * 
     * @type {any}
     * @memberof BulkUpdateRequest
     */
    'updated_by': any;
    /**
     * 
     * @type {any}
     * @memberof BulkUpdateRequest
     */
    'assignee_id'?: any;
    /**
     * 
     * @type {ActionType}
     * @memberof BulkUpdateRequest
     */
    'action': ActionType;
}


/**
 * 
 * @export
 * @interface CAProvinceCode
 */
export interface CAProvinceCode {
}
/**
 * 
 * @export
 * @interface ChatFollowUp
 */
export interface ChatFollowUp {
    /**
     * 
     * @type {any}
     * @memberof ChatFollowUp
     */
    'type': any;
    /**
     * 
     * @type {any}
     * @memberof ChatFollowUp
     */
    'items': any;
}
/**
 * 
 * @export
 * @interface ChatFollowUpItem
 */
export interface ChatFollowUpItem {
    /**
     * 
     * @type {any}
     * @memberof ChatFollowUpItem
     */
    'id': any;
}
/**
 * 
 * @export
 * @interface Checklist
 */
export interface Checklist {
    /**
     * 
     * @type {any}
     * @memberof Checklist
     */
    'definition_id': any;
    /**
     * 
     * @type {any}
     * @memberof Checklist
     */
    'item_definition_id': any;
}
/**
 * 
 * @export
 * @interface ChecklistItemError
 */
export interface ChecklistItemError {
    /**
     * 
     * @type {any}
     * @memberof ChecklistItemError
     */
    'id': any;
    /**
     * 
     * @type {any}
     * @memberof ChecklistItemError
     */
    'files'?: any;
}
/**
 * 
 * @export
 * @interface ChecklistItemErrorsRequest
 */
export interface ChecklistItemErrorsRequest {
    /**
     * 
     * @type {any}
     * @memberof ChecklistItemErrorsRequest
     */
    'checklist_item_ids'?: any;
}
/**
 * 
 * @export
 * @interface ChecklistItemErrorsResponse
 */
export interface ChecklistItemErrorsResponse {
    /**
     * 
     * @type {any}
     * @memberof ChecklistItemErrorsResponse
     */
    'checklist_items'?: any;
}
/**
 * 
 * @export
 * @interface ChecklistItemFile
 */
export interface ChecklistItemFile {
    /**
     * 
     * @type {any}
     * @memberof ChecklistItemFile
     */
    'id': any;
    /**
     * 
     * @type {DocumentReviewStatus}
     * @memberof ChecklistItemFile
     */
    'status': DocumentReviewStatus;
    /**
     * 
     * @type {any}
     * @memberof ChecklistItemFile
     */
    'result'?: any;
    /**
     * 
     * @type {any}
     * @memberof ChecklistItemFile
     */
    'document_review_id'?: any;
}


/**
 * 
 * @export
 * @interface ContextMetadataSources
 */
export interface ContextMetadataSources {
    /**
     * 
     * @type {any}
     * @memberof ContextMetadataSources
     */
    'apis'?: any;
    /**
     * 
     * @type {any}
     * @memberof ContextMetadataSources
     */
    'faqs'?: any;
    /**
     * 
     * @type {any}
     * @memberof ContextMetadataSources
     */
    'docs'?: any;
    /**
     * 
     * @type {any}
     * @memberof ContextMetadataSources
     */
    'simba'?: any;
}
/**
 * 
 * @export
 * @interface Country
 */
export interface Country {
}
/**
 * 
 * @export
 * @interface CountryV2
 */
export interface CountryV2 {
}
/**
 * 
 * @export
 * @interface DocSource
 */
export interface DocSource {
    /**
     * 
     * @type {any}
     * @memberof DocSource
     */
    'id'?: any;
    /**
     * 
     * @type {any}
     * @memberof DocSource
     */
    'type'?: any;
    /**
     * 
     * @type {any}
     * @memberof DocSource
     */
    'url'?: any;
    /**
     * 
     * @type {any}
     * @memberof DocSource
     */
    'content'?: any;
    /**
     * 
     * @type {any}
     * @memberof DocSource
     */
    'cmetadata'?: any;
}
/**
 * 
 * @export
 * @interface DocumentReviewDetectedError
 */
export interface DocumentReviewDetectedError {
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewDetectedError
     */
    'error_message': any;
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewDetectedError
     */
    'page_numbers': any;
}
/**
 * 
 * @export
 * @interface DocumentReviewMetrics
 */
export interface DocumentReviewMetrics {
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewMetrics
     */
    'total_count': any;
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewMetrics
     */
    'success_count': any;
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewMetrics
     */
    'success_with_errors_count': any;
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewMetrics
     */
    'success_without_errors_count': any;
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewMetrics
     */
    'skipped_count': any;
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewMetrics
     */
    'failed_count': any;
}
/**
 * 
 * @export
 * @interface DocumentReviewReactionRequest
 */
export interface DocumentReviewReactionRequest {
    /**
     * 
     * @type {ReactionType}
     * @memberof DocumentReviewReactionRequest
     */
    'reaction': ReactionType;
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewReactionRequest
     */
    'user_id': any;
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewReactionRequest
     */
    'yada_comment_id'?: any;
}


/**
 * 
 * @export
 * @interface DocumentReviewReactionResponse
 */
export interface DocumentReviewReactionResponse {
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewReactionResponse
     */
    'id': any;
    /**
     * 
     * @type {ReactionType}
     * @memberof DocumentReviewReactionResponse
     */
    'reaction': ReactionType;
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewReactionResponse
     */
    'created_at': any;
}


/**
 * 
 * @export
 * @interface DocumentReviewResponse
 */
export interface DocumentReviewResponse {
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewResponse
     */
    'id': any;
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewResponse
     */
    'file_reference_id': any;
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewResponse
     */
    'checklist_item_id': any;
    /**
     * 
     * @type {DocumentReviewStatus}
     * @memberof DocumentReviewResponse
     */
    'status': DocumentReviewStatus;
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewResponse
     */
    'reactions'?: any;
}


/**
 * 
 * @export
 * @interface DocumentReviewResult
 */
export interface DocumentReviewResult {
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewResult
     */
    'detected_errors'?: any;
}
/**
 * 
 * @export
 * @interface DocumentReviewStatus
 */
export interface DocumentReviewStatus {
}
/**
 * 
 * @export
 * @interface DocumentReviewTemplateLimits
 */
export interface DocumentReviewTemplateLimits {
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewTemplateLimits
     */
    'min_sample_size': any;
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewTemplateLimits
     */
    'validator_failure_threshold': any;
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewTemplateLimits
     */
    'validator_skip_threshold': any;
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewTemplateLimits
     */
    'exception_threshold': any;
}
/**
 * 
 * @export
 * @interface DocumentReviewTemplateResponse
 */
export interface DocumentReviewTemplateResponse {
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewTemplateResponse
     */
    'id': any;
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewTemplateResponse
     */
    'name': any;
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewTemplateResponse
     */
    'country'?: any;
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewTemplateResponse
     */
    'state_or_province'?: any;
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewTemplateResponse
     */
    'version'?: any;
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewTemplateResponse
     */
    'slug': any;
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewTemplateResponse
     */
    'item_definitions'?: any;
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewTemplateResponse
     */
    'is_enabled'?: any;
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewTemplateResponse
     */
    'enabled_at'?: any;
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewTemplateResponse
     */
    'modified_by'?: any;
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewTemplateResponse
     */
    'modified_at': any;
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewTemplateResponse
     */
    'created_at': any;
    /**
     * 
     * @type {DocumentReviewTemplateLimits}
     * @memberof DocumentReviewTemplateResponse
     */
    'limits': DocumentReviewTemplateLimits;
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewTemplateResponse
     */
    'metrics'?: any;
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewTemplateResponse
     */
    'last_review_at'?: any;
}
/**
 * 
 * @export
 * @interface DocumentReviewTemplateUpdateRequest
 */
export interface DocumentReviewTemplateUpdateRequest {
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewTemplateUpdateRequest
     */
    'is_enabled'?: any;
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewTemplateUpdateRequest
     */
    'checklists'?: any;
    /**
     * 
     * @type {any}
     * @memberof DocumentReviewTemplateUpdateRequest
     */
    'limits'?: any;
}
/**
 * 
 * @export
 * @interface FaqSource
 */
export interface FaqSource {
    /**
     * 
     * @type {any}
     * @memberof FaqSource
     */
    'id'?: any;
    /**
     * 
     * @type {any}
     * @memberof FaqSource
     */
    'question'?: any;
    /**
     * 
     * @type {any}
     * @memberof FaqSource
     */
    'answer'?: any;
}
/**
 * 
 * @export
 * @interface FollowUpAPITypes
 */
export interface FollowUpAPITypes {
}
/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {any}
     * @memberof HTTPValidationError
     */
    'detail'?: any;
}
/**
 * 
 * @export
 * @interface ListResourceDocumentReviewTemplateResponse
 */
export interface ListResourceDocumentReviewTemplateResponse {
    /**
     * 
     * @type {any}
     * @memberof ListResourceDocumentReviewTemplateResponse
     */
    'items'?: any;
    /**
     * 
     * @type {Pagination}
     * @memberof ListResourceDocumentReviewTemplateResponse
     */
    'pagination': Pagination;
}
/**
 * 
 * @export
 * @interface ListResourceNotificationResponse
 */
export interface ListResourceNotificationResponse {
    /**
     * 
     * @type {any}
     * @memberof ListResourceNotificationResponse
     */
    'items'?: any;
    /**
     * 
     * @type {Pagination}
     * @memberof ListResourceNotificationResponse
     */
    'pagination': Pagination;
}
/**
 * 
 * @export
 * @interface ListResourceSession
 */
export interface ListResourceSession {
    /**
     * 
     * @type {any}
     * @memberof ListResourceSession
     */
    'items'?: any;
    /**
     * 
     * @type {Pagination}
     * @memberof ListResourceSession
     */
    'pagination': Pagination;
}
/**
 * 
 * @export
 * @interface MaterialReviewRequest
 */
export interface MaterialReviewRequest {
    /**
     * 
     * @type {any}
     * @memberof MaterialReviewRequest
     */
    'attachment_ids'?: any;
    /**
     * 
     * @type {any}
     * @memberof MaterialReviewRequest
     */
    'element_selections'?: any;
    /**
     * 
     * @type {MaterialReviewType}
     * @memberof MaterialReviewRequest
     */
    'form_id': MaterialReviewType;
}


/**
 * 
 * @export
 * @interface MaterialReviewResponse
 */
export interface MaterialReviewResponse {
    /**
     * 
     * @type {any}
     * @memberof MaterialReviewResponse
     */
    'id': any;
    /**
     * 
     * @type {any}
     * @memberof MaterialReviewResponse
     */
    'user_id': any;
    /**
     * 
     * @type {MaterialReviewStatus}
     * @memberof MaterialReviewResponse
     */
    'status': MaterialReviewStatus;
    /**
     * 
     * @type {MaterialReviewType}
     * @memberof MaterialReviewResponse
     */
    'type': MaterialReviewType;
    /**
     * 
     * @type {any}
     * @memberof MaterialReviewResponse
     */
    'attachment_ids': any;
}


/**
 * 
 * @export
 * @interface MaterialReviewStatus
 */
export interface MaterialReviewStatus {
}
/**
 * 
 * @export
 * @interface MaterialReviewType
 */
export interface MaterialReviewType {
}
/**
 * 
 * @export
 * @interface MediaItem
 */
export interface MediaItem {
    /**
     * 
     * @type {any}
     * @memberof MediaItem
     */
    'type'?: any;
    /**
     * 
     * @type {any}
     * @memberof MediaItem
     */
    'source_url': any;
    /**
     * 
     * @type {any}
     * @memberof MediaItem
     */
    's3_url'?: any;
    /**
     * 
     * @type {any}
     * @memberof MediaItem
     */
    'template_name'?: any;
    /**
     * 
     * @type {any}
     * @memberof MediaItem
     */
    'media_url'?: any;
    /**
     * 
     * @type {any}
     * @memberof MediaItem
     */
    'thumbnail': any;
    /**
     * 
     * @type {any}
     * @memberof MediaItem
     */
    'template_url'?: any;
    /**
     * 
     * @type {any}
     * @memberof MediaItem
     */
    'mimetype'?: any;
    /**
     * 
     * @type {any}
     * @memberof MediaItem
     */
    'height'?: any;
    /**
     * 
     * @type {any}
     * @memberof MediaItem
     */
    'width'?: any;
    /**
     * 
     * @type {any}
     * @memberof MediaItem
     */
    'title'?: any;
    /**
     * 
     * @type {any}
     * @memberof MediaItem
     */
    'sub_title'?: any;
    /**
     * 
     * @type {any}
     * @memberof MediaItem
     */
    'mark_down'?: any;
}
/**
 * 
 * @export
 * @interface MediaType
 */
export interface MediaType {
}
/**
 * Schema for a chat message with ID and creation time.
 * @export
 * @interface Message
 */
export interface Message {
    /**
     * 
     * @type {any}
     * @memberof Message
     */
    'id'?: any;
    /**
     * 
     * @type {any}
     * @memberof Message
     */
    'session_id': any;
    /**
     * 
     * @type {any}
     * @memberof Message
     */
    'parent_id'?: any;
    /**
     * 
     * @type {any}
     * @memberof Message
     */
    'message'?: any;
    /**
     * 
     * @type {any}
     * @memberof Message
     */
    'latency'?: any;
    /**
     * 
     * @type {any}
     * @memberof Message
     */
    'tokens'?: any;
    /**
     * 
     * @type {any}
     * @memberof Message
     */
    'cost'?: any;
    /**
     * Source of the user message
     * @type {any}
     * @memberof Message
     */
    'source'?: any;
    /**
     * 
     * @type {any}
     * @memberof Message
     */
    'media'?: any;
    /**
     * 
     * @type {any}
     * @memberof Message
     */
    'support_flow_details'?: any;
    /**
     * 
     * @type {UserIntentType}
     * @memberof Message
     */
    'user_intent_type'?: UserIntentType;
    /**
     * 
     * @type {any}
     * @memberof Message
     */
    'context_metadata'?: any;
    /**
     * 
     * @type {any}
     * @memberof Message
     */
    'has_support_reference'?: any;
    /**
     * 
     * @type {any}
     * @memberof Message
     */
    'generation_time_ms'?: any;
    /**
     * 
     * @type {any}
     * @memberof Message
     */
    'preparation_time_ms'?: any;
    /**
     * 
     * @type {any}
     * @memberof Message
     */
    'operation_latencies'?: any;
    /**
     * 
     * @type {MessageSenderTypes}
     * @memberof Message
     */
    'sender': MessageSenderTypes;
    /**
     * 
     * @type {any}
     * @memberof Message
     */
    'vote_type'?: any;
    /**
     * 
     * @type {any}
     * @memberof Message
     */
    'created_at'?: any;
}


/**
 * 
 * @export
 * @interface MessageActionRequest
 */
export interface MessageActionRequest {
    /**
     * 
     * @type {any}
     * @memberof MessageActionRequest
     */
    'text': any;
    /**
     * 
     * @type {any}
     * @memberof MessageActionRequest
     */
    'payload'?: any;
}
/**
 * 
 * @export
 * @interface MessageSenderTypes
 */
export interface MessageSenderTypes {
}
/**
 * 
 * @export
 * @interface MessageSourceType
 */
export interface MessageSourceType {
}
/**
 * 
 * @export
 * @interface ModalElement
 */
export interface ModalElement {
    /**
     * 
     * @type {any}
     * @memberof ModalElement
     */
    'key': any;
    /**
     * 
     * @type {any}
     * @memberof ModalElement
     */
    'label': any;
    /**
     * 
     * @type {any}
     * @memberof ModalElement
     */
    'options'?: any;
}
/**
 * 
 * @export
 * @interface ModalElementOption
 */
export interface ModalElementOption {
    /**
     * 
     * @type {any}
     * @memberof ModalElementOption
     */
    'label': any;
    /**
     * 
     * @type {any}
     * @memberof ModalElementOption
     */
    'value': any;
}
/**
 * 
 * @export
 * @interface ModalElementSelection
 */
export interface ModalElementSelection {
    /**
     * 
     * @type {any}
     * @memberof ModalElementSelection
     */
    'key': any;
    /**
     * 
     * @type {any}
     * @memberof ModalElementSelection
     */
    'values'?: any;
}
/**
 * 
 * @export
 * @interface ModifiedBy
 */
export interface ModifiedBy {
    /**
     * 
     * @type {any}
     * @memberof ModifiedBy
     */
    'id': any;
    /**
     * 
     * @type {any}
     * @memberof ModifiedBy
     */
    'name'?: any;
}
/**
 * if a prompt is provided, it will be interpreted as a Leo prompt; if an url is included, it will redirect to that url.
 * @export
 * @interface NotificationAction
 */
export interface NotificationAction {
    /**
     * 
     * @type {any}
     * @memberof NotificationAction
     */
    'text': any;
    /**
     * 
     * @type {NotificationActionType}
     * @memberof NotificationAction
     */
    'type'?: NotificationActionType;
    /**
     * 
     * @type {NotificationActionCategory}
     * @memberof NotificationAction
     */
    'category'?: NotificationActionCategory;
    /**
     * 
     * @type {any}
     * @memberof NotificationAction
     */
    'url'?: any;
    /**
     * 
     * @type {any}
     * @memberof NotificationAction
     */
    'prompt'?: any;
}


/**
 * 
 * @export
 * @interface NotificationActionCategory
 */
export interface NotificationActionCategory {
}
/**
 * 
 * @export
 * @interface NotificationActionRequest
 */
export interface NotificationActionRequest {
    /**
     * 
     * @type {any}
     * @memberof NotificationActionRequest
     */
    'text': any;
}
/**
 * 
 * @export
 * @interface NotificationActionType
 */
export interface NotificationActionType {
}
/**
 * 
 * @export
 * @interface NotificationEventRequest
 */
export interface NotificationEventRequest {
    /**
     * 
     * @type {NotificationEventType}
     * @memberof NotificationEventRequest
     */
    'event_type': NotificationEventType;
}


/**
 * 
 * @export
 * @interface NotificationEventType
 */
export interface NotificationEventType {
}
/**
 * 
 * @export
 * @interface NotificationMenuItem
 */
export interface NotificationMenuItem {
    /**
     * 
     * @type {NotificationEventType}
     * @memberof NotificationMenuItem
     */
    'type': NotificationEventType;
    /**
     * 
     * @type {any}
     * @memberof NotificationMenuItem
     */
    'text': any;
    /**
     * 
     * @type {any}
     * @memberof NotificationMenuItem
     */
    'icon': any;
}


/**
 * 
 * @export
 * @interface NotificationResponse
 */
export interface NotificationResponse {
    /**
     * 
     * @type {any}
     * @memberof NotificationResponse
     */
    'id': any;
    /**
     * 
     * @type {NotificationType}
     * @memberof NotificationResponse
     */
    'type'?: NotificationType;
    /**
     * 
     * @type {any}
     * @memberof NotificationResponse
     */
    'title': any;
    /**
     * 
     * @type {any}
     * @memberof NotificationResponse
     */
    'description': any;
    /**
     * 
     * @type {any}
     * @memberof NotificationResponse
     */
    'priority': any;
    /**
     * 
     * @type {any}
     * @memberof NotificationResponse
     */
    'actions'?: any;
    /**
     * 
     * @type {any}
     * @memberof NotificationResponse
     */
    'suggested_prompts'?: any;
    /**
     * 
     * @type {any}
     * @memberof NotificationResponse
     */
    'created_at': any;
    /**
     * 
     * @type {any}
     * @memberof NotificationResponse
     */
    'menu_items'?: any;
    /**
     * 
     * @type {any}
     * @memberof NotificationResponse
     */
    'is_recent'?: any;
}


/**
 * 
 * @export
 * @interface NotificationType
 */
export interface NotificationType {
}
/**
 * 
 * @export
 * @interface OfficeGroupName
 */
export interface OfficeGroupName {
}
/**
 * 
 * @export
 * @interface PaginatedPairResponse
 */
export interface PaginatedPairResponse {
    /**
     * 
     * @type {any}
     * @memberof PaginatedPairResponse
     */
    'has_next': any;
    /**
     * 
     * @type {any}
     * @memberof PaginatedPairResponse
     */
    'total_count': any;
    /**
     * 
     * @type {any}
     * @memberof PaginatedPairResponse
     */
    'page': any;
    /**
     * 
     * @type {any}
     * @memberof PaginatedPairResponse
     */
    'data': any;
}
/**
 * 
 * @export
 * @interface Pagination
 */
export interface Pagination {
    /**
     * 
     * @type {any}
     * @memberof Pagination
     */
    'total_count': any;
    /**
     * 
     * @type {any}
     * @memberof Pagination
     */
    'max_page': any;
}
/**
 * 
 * @export
 * @interface PairBaseTopics
 */
export interface PairBaseTopics {
    /**
     * 
     * @type {any}
     * @memberof PairBaseTopics
     */
    'pair_id'?: any;
    /**
     * 
     * @type {any}
     * @memberof PairBaseTopics
     */
    'question': any;
    /**
     * 
     * @type {any}
     * @memberof PairBaseTopics
     */
    'answer'?: any;
    /**
     * 
     * @type {any}
     * @memberof PairBaseTopics
     */
    'user_id'?: any;
    /**
     * 
     * @type {any}
     * @memberof PairBaseTopics
     */
    'assignee_id'?: any;
    /**
     * 
     * @type {any}
     * @memberof PairBaseTopics
     */
    'message_id'?: any;
    /**
     * 
     * @type {any}
     * @memberof PairBaseTopics
     */
    'created_at'?: any;
    /**
     * 
     * @type {any}
     * @memberof PairBaseTopics
     */
    'updated_at': any;
    /**
     * 
     * @type {any}
     * @memberof PairBaseTopics
     */
    'updated_by'?: any;
    /**
     * 
     * @type {any}
     * @memberof PairBaseTopics
     */
    'is_enabled'?: any;
    /**
     * 
     * @type {any}
     * @memberof PairBaseTopics
     */
    'start_date'?: any;
    /**
     * 
     * @type {any}
     * @memberof PairBaseTopics
     */
    'end_date'?: any;
    /**
     * 
     * @type {any}
     * @memberof PairBaseTopics
     */
    'reason'?: any;
    /**
     * 
     * @type {any}
     * @memberof PairBaseTopics
     */
    'country'?: any;
    /**
     * 
     * @type {any}
     * @memberof PairBaseTopics
     */
    'state_province'?: any;
    /**
     * 
     * @type {any}
     * @memberof PairBaseTopics
     */
    'deleted_at'?: any;
    /**
     * 
     * @type {any}
     * @memberof PairBaseTopics
     */
    'topics'?: any;
}
/**
 * 
 * @export
 * @interface PairRequest
 */
export interface PairRequest {
    /**
     * 
     * @type {any}
     * @memberof PairRequest
     */
    'start_date'?: any;
    /**
     * 
     * @type {any}
     * @memberof PairRequest
     */
    'end_date'?: any;
    /**
     * 
     * @type {any}
     * @memberof PairRequest
     */
    'is_enabled': any;
    /**
     * 
     * @type {any}
     * @memberof PairRequest
     */
    'assignee_id'?: any;
    /**
     * 
     * @type {any}
     * @memberof PairRequest
     */
    'question': any;
    /**
     * 
     * @type {any}
     * @memberof PairRequest
     */
    'answer'?: any;
    /**
     * 
     * @type {any}
     * @memberof PairRequest
     */
    'country'?: any;
    /**
     * 
     * @type {any}
     * @memberof PairRequest
     */
    'state_province'?: any;
    /**
     * 
     * @type {any}
     * @memberof PairRequest
     */
    'user_id'?: any;
    /**
     * 
     * @type {any}
     * @memberof PairRequest
     */
    'reason'?: any;
    /**
     * 
     * @type {any}
     * @memberof PairRequest
     */
    'message_id'?: any;
}
/**
 * 
 * @export
 * @interface PromptLibraryItem
 */
export interface PromptLibraryItem {
    /**
     * 
     * @type {any}
     * @memberof PromptLibraryItem
     */
    'title': any;
    /**
     * 
     * @type {any}
     * @memberof PromptLibraryItem
     */
    'prompt': any;
    /**
     * 
     * @type {PromptType}
     * @memberof PromptLibraryItem
     */
    'prompt_type'?: PromptType;
    /**
     * 
     * @type {any}
     * @memberof PromptLibraryItem
     */
    'category'?: any;
}


/**
 * 
 * @export
 * @interface PromptLibraryRequest
 */
export interface PromptLibraryRequest {
    /**
     * 
     * @type {any}
     * @memberof PromptLibraryRequest
     */
    'source': any;
    /**
     * 
     * @type {any}
     * @memberof PromptLibraryRequest
     */
    'limit'?: any;
    /**
     * 
     * @type {any}
     * @memberof PromptLibraryRequest
     */
    'offset'?: any;
}
/**
 * 
 * @export
 * @interface PromptLibraryResponse
 */
export interface PromptLibraryResponse {
    /**
     * 
     * @type {any}
     * @memberof PromptLibraryResponse
     */
    'items'?: any;
    /**
     * 
     * @type {any}
     * @memberof PromptLibraryResponse
     */
    'total': any;
    /**
     * 
     * @type {any}
     * @memberof PromptLibraryResponse
     */
    'limit': any;
    /**
     * 
     * @type {any}
     * @memberof PromptLibraryResponse
     */
    'offset': any;
}
/**
 * 
 * @export
 * @interface PromptType
 */
export interface PromptType {
}
/**
 * 
 * @export
 * @interface QueueCountResponse
 */
export interface QueueCountResponse {
    /**
     * 
     * @type {any}
     * @memberof QueueCountResponse
     */
    'work_queue_total': any;
    /**
     * 
     * @type {any}
     * @memberof QueueCountResponse
     */
    'assigned_total': any;
    /**
     * 
     * @type {any}
     * @memberof QueueCountResponse
     */
    'completed_total': any;
}
/**
 * Same types as defined in Yada
 * @export
 * @interface ReactionType
 */
export interface ReactionType {
}
/**
 * 
 * @export
 * @interface RealAppName
 */
export interface RealAppName {
}
/**
 * 
 * @export
 * @interface Reason
 */
export interface Reason {
}
/**
 * Response context saved in db for debugging
 * @export
 * @interface ResponseContextMetadata
 */
export interface ResponseContextMetadata {
    /**
     * 
     * @type {any}
     * @memberof ResponseContextMetadata
     */
    'api_context'?: any;
    /**
     * 
     * @type {any}
     * @memberof ResponseContextMetadata
     */
    'faq_context'?: any;
    /**
     * 
     * @type {any}
     * @memberof ResponseContextMetadata
     */
    'zendesk_context'?: any;
    /**
     * 
     * @type {any}
     * @memberof ResponseContextMetadata
     */
    'api_contexts'?: any;
    /**
     * 
     * @type {any}
     * @memberof ResponseContextMetadata
     */
    'faq_contexts'?: any;
    /**
     * 
     * @type {any}
     * @memberof ResponseContextMetadata
     */
    'zendesk_contexts'?: any;
    /**
     * 
     * @type {any}
     * @memberof ResponseContextMetadata
     */
    'sources'?: any;
    /**
     * 
     * @type {any}
     * @memberof ResponseContextMetadata
     */
    'disambiguation'?: any;
    /**
     * True if the response is hallucinated
     * @type {any}
     * @memberof ResponseContextMetadata
     */
    'hallucinated'?: any;
    /**
     * 
     * @type {any}
     * @memberof ResponseContextMetadata
     */
    'transaction_comments_meta'?: any;
}
/**
 * 
 * @export
 * @interface RezenObject
 */
export interface RezenObject {
    /**
     * 
     * @type {any}
     * @memberof RezenObject
     */
    'id': any;
    /**
     * 
     * @type {any}
     * @memberof RezenObject
     */
    'type': any;
}
/**
 * 
 * @export
 * @interface RezenObjectType
 */
export interface RezenObjectType {
}
/**
 * 
 * @export
 * @interface RoarContainerType
 */
export interface RoarContainerType {
}
/**
 * 
 * @export
 * @interface RoarItemInput
 */
export interface RoarItemInput {
    /**
     * 
     * @type {any}
     * @memberof RoarItemInput
     */
    'title': any;
    /**
     * 
     * @type {any}
     * @memberof RoarItemInput
     */
    'url'?: any;
    /**
     * 
     * @type {any}
     * @memberof RoarItemInput
     */
    'prompt'?: any;
    /**
     * 
     * @type {any}
     * @memberof RoarItemInput
     */
    'prompt_type'?: any;
    /**
     * 
     * @type {any}
     * @memberof RoarItemInput
     */
    'interaction'?: any;
    /**
     * 
     * @type {SearchRoarItemActionType}
     * @memberof RoarItemInput
     */
    'action_type'?: SearchRoarItemActionType;
    /**
     * 
     * @type {any}
     * @memberof RoarItemInput
     */
    'office_group_id': any;
    /**
     * 
     * @type {any}
     * @memberof RoarItemInput
     */
    'office_group_name'?: any;
    /**
     * 
     * @type {RoarTargetGroupType}
     * @memberof RoarItemInput
     */
    'target_type'?: RoarTargetGroupType;
    /**
     * 
     * @type {any}
     * @memberof RoarItemInput
     */
    'container_id'?: any;
    /**
     * 
     * @type {any}
     * @memberof RoarItemInput
     */
    'container_type'?: any;
    /**
     * 
     * @type {any}
     * @memberof RoarItemInput
     */
    'agent_id': any;
}


/**
 * 
 * @export
 * @interface RoarItemOutput
 */
export interface RoarItemOutput {
    /**
     * 
     * @type {any}
     * @memberof RoarItemOutput
     */
    'title': any;
    /**
     * 
     * @type {any}
     * @memberof RoarItemOutput
     */
    'url'?: any;
    /**
     * 
     * @type {any}
     * @memberof RoarItemOutput
     */
    'prompt'?: any;
    /**
     * 
     * @type {any}
     * @memberof RoarItemOutput
     */
    'prompt_type'?: any;
    /**
     * 
     * @type {any}
     * @memberof RoarItemOutput
     */
    'interaction'?: any;
    /**
     * 
     * @type {SearchRoarItemActionType}
     * @memberof RoarItemOutput
     */
    'action_type'?: SearchRoarItemActionType;
    /**
     * 
     * @type {any}
     * @memberof RoarItemOutput
     */
    'office_group_id': any;
    /**
     * 
     * @type {any}
     * @memberof RoarItemOutput
     */
    'office_group_name'?: any;
    /**
     * 
     * @type {RoarTargetGroupType}
     * @memberof RoarItemOutput
     */
    'target_type'?: RoarTargetGroupType;
    /**
     * 
     * @type {any}
     * @memberof RoarItemOutput
     */
    'container_id'?: any;
    /**
     * 
     * @type {any}
     * @memberof RoarItemOutput
     */
    'container_type'?: any;
    /**
     * 
     * @type {any}
     * @memberof RoarItemOutput
     */
    'agent_id': any;
}


/**
 * 
 * @export
 * @interface RoarTargetGroupType
 */
export interface RoarTargetGroupType {
}
/**
 * 
 * @export
 * @interface RoarTitle
 */
export interface RoarTitle {
}
/**
 * 
 * @export
 * @interface SearchActionRequest
 */
export interface SearchActionRequest {
    /**
     * 
     * @type {any}
     * @memberof SearchActionRequest
     */
    'category': any;
    /**
     * 
     * @type {any}
     * @memberof SearchActionRequest
     */
    'item': any;
}
/**
 * 
 * @export
 * @interface SearchCategory
 */
export enum SearchCategory {
    InternalPages = 'INTERNAL_PAGES',
    ExternalLinks = 'EXTERNAL_LINKS',
    PromptSuggestions = 'PROMPT_SUGGESTIONS',
    Deposits = 'DEPOSITS',
    Roar = 'ROAR',
    MarketingSignReview = 'MARKETING_SIGN_REVIEW'
}
/**
 * 
 * @export
 * @interface SearchChatAction
 */
export interface SearchChatAction {
    /**
     * 
     * @type {any}
     * @memberof SearchChatAction
     */
    'type'?: any;
    /**
     * 
     * @type {any}
     * @memberof SearchChatAction
     */
    'request_params'?: any;
}
/**
 * 
 * @export
 * @interface SearchItemInput
 */
export interface SearchItemInput {
    /**
     * 
     * @type {any}
     * @memberof SearchItemInput
     */
    'title': any;
    /**
     * 
     * @type {any}
     * @memberof SearchItemInput
     */
    'url'?: any;
    /**
     * 
     * @type {any}
     * @memberof SearchItemInput
     */
    'prompt'?: any;
    /**
     * 
     * @type {any}
     * @memberof SearchItemInput
     */
    'prompt_type'?: any;
    /**
     * 
     * @type {any}
     * @memberof SearchItemInput
     */
    'interaction'?: any;
}
/**
 * 
 * @export
 * @interface SearchItemOutput
 */
export interface SearchItemOutput {
    /**
     * 
     * @type {any}
     * @memberof SearchItemOutput
     */
    'title': any;
    /**
     * 
     * @type {any}
     * @memberof SearchItemOutput
     */
    'url'?: any;
    /**
     * 
     * @type {any}
     * @memberof SearchItemOutput
     */
    'prompt'?: any;
    /**
     * 
     * @type {any}
     * @memberof SearchItemOutput
     */
    'prompt_type'?: any;
    /**
     * 
     * @type {any}
     * @memberof SearchItemOutput
     */
    'interaction'?: any;
}
/**
 * 
 * @export
 * @interface SearchModalActionDataInput
 */
export interface SearchModalActionDataInput {
    /**
     * Modal title
     * @type {any}
     * @memberof SearchModalActionDataInput
     */
    'title': any;
    /**
     * 
     * @type {any}
     * @memberof SearchModalActionDataInput
     */
    'content_section'?: any;
    /**
     * Max file size in megabytes
     * @type {any}
     * @memberof SearchModalActionDataInput
     */
    'file_max_size'?: any;
    /**
     * Max file count
     * @type {any}
     * @memberof SearchModalActionDataInput
     */
    'file_max_count'?: any;
    /**
     * 
     * @type {any}
     * @memberof SearchModalActionDataInput
     */
    'file_allowed_mime_types'?: any;
    /**
     * 
     * @type {any}
     * @memberof SearchModalActionDataInput
     */
    'elements'?: any;
}
/**
 * 
 * @export
 * @interface SearchModalActionDataOutput
 */
export interface SearchModalActionDataOutput {
    /**
     * Modal title
     * @type {any}
     * @memberof SearchModalActionDataOutput
     */
    'title': any;
    /**
     * 
     * @type {any}
     * @memberof SearchModalActionDataOutput
     */
    'content_section'?: any;
    /**
     * Max file size in megabytes
     * @type {any}
     * @memberof SearchModalActionDataOutput
     */
    'file_max_size'?: any;
    /**
     * Max file count
     * @type {any}
     * @memberof SearchModalActionDataOutput
     */
    'file_max_count'?: any;
    /**
     * 
     * @type {any}
     * @memberof SearchModalActionDataOutput
     */
    'file_allowed_mime_types'?: any;
    /**
     * 
     * @type {any}
     * @memberof SearchModalActionDataOutput
     */
    'elements'?: any;
}
/**
 * 
 * @export
 * @interface SearchModalActionInput
 */
export interface SearchModalActionInput {
    /**
     * 
     * @type {any}
     * @memberof SearchModalActionInput
     */
    'type'?: any;
    /**
     * 
     * @type {SearchModalActionDataInput}
     * @memberof SearchModalActionInput
     */
    'data': SearchModalActionDataInput;
    /**
     * 
     * @type {MaterialReviewType}
     * @memberof SearchModalActionInput
     */
    'form_id': MaterialReviewType;
}


/**
 * 
 * @export
 * @interface SearchModalActionOutput
 */
export interface SearchModalActionOutput {
    /**
     * 
     * @type {any}
     * @memberof SearchModalActionOutput
     */
    'type'?: any;
    /**
     * 
     * @type {SearchModalActionDataOutput}
     * @memberof SearchModalActionOutput
     */
    'data': SearchModalActionDataOutput;
    /**
     * 
     * @type {MaterialReviewType}
     * @memberof SearchModalActionOutput
     */
    'form_id': MaterialReviewType;
}


/**
 * 
 * @export
 * @interface SearchRedirectAction
 */
export interface SearchRedirectAction {
    /**
     * 
     * @type {any}
     * @memberof SearchRedirectAction
     */
    'type'?: any;
    /**
     * 
     * @type {any}
     * @memberof SearchRedirectAction
     */
    'url': any;
}
/**
 * 
 * @export
 * @interface SearchResponse
 */
export interface SearchResponse {
    /**
     * 
     * @type {any}
     * @memberof SearchResponse
     */
    'results'?: any;
}
/**
 * 
 * @export
 * @interface SearchResult
 */
export interface SearchResult {
    /**
     * 
     * @type {SearchCategory}
     * @memberof SearchResult
     */
    'category': SearchCategory;
    /**
     * 
     * @type {any}
     * @memberof SearchResult
     */
    'category_title'?: any;
    /**
     * 
     * @type {any}
     * @memberof SearchResult
     */
    'items': any;
}


/**
 * 
 * @export
 * @interface SearchRoarAction
 */
export interface SearchRoarAction {
    /**
     * 
     * @type {any}
     * @memberof SearchRoarAction
     */
    'type'?: any;
    /**
     * 
     * @type {RoarTargetGroupType}
     * @memberof SearchRoarAction
     */
    'target_type'?: RoarTargetGroupType;
    /**
     * 
     * @type {SearchRoarItemActionType}
     * @memberof SearchRoarAction
     */
    'action_type'?: SearchRoarItemActionType;
    /**
     * 
     * @type {any}
     * @memberof SearchRoarAction
     */
    'title': any;
    /**
     * 
     * @type {any}
     * @memberof SearchRoarAction
     */
    'office_group_id': any;
    /**
     * 
     * @type {any}
     * @memberof SearchRoarAction
     */
    'office_group_name'?: any;
    /**
     * 
     * @type {any}
     * @memberof SearchRoarAction
     */
    'container_id'?: any;
    /**
     * 
     * @type {any}
     * @memberof SearchRoarAction
     */
    'container_type'?: any;
    /**
     * 
     * @type {any}
     * @memberof SearchRoarAction
     */
    'agent_id': any;
}


/**
 * 
 * @export
 * @interface SearchRoarItemActionType
 */
export interface SearchRoarItemActionType {
}
/**
 * Schema for a chat session with ID and timestamps.
 * @export
 * @interface Session
 */
export interface Session {
    /**
     * 
     * @type {any}
     * @memberof Session
     */
    'id': any;
    /**
     * 
     * @type {any}
     * @memberof Session
     */
    'agent_id': any;
    /**
     * 
     * @type {any}
     * @memberof Session
     */
    'start_time'?: any;
    /**
     * 
     * @type {any}
     * @memberof Session
     */
    'system_message'?: any;
    /**
     * 
     * @type {any}
     * @memberof Session
     */
    'title'?: any;
    /**
     * 
     * @type {SessionEntrypoint}
     * @memberof Session
     */
    'entrypoint': SessionEntrypoint;
    /**
     * 
     * @type {any}
     * @memberof Session
     */
    'real_app_name'?: any;
    /**
     * 
     * @type {any}
     * @memberof Session
     */
    'notification_id'?: any;
}


/**
 * 
 * @export
 * @interface SessionEntrypoint
 */
export interface SessionEntrypoint {
}
/**
 * Schema for creating a new chat session.
 * @export
 * @interface SessionRequest
 */
export interface SessionRequest {
    /**
     * 
     * @type {any}
     * @memberof SessionRequest
     */
    'agent_id': any;
    /**
     * 
     * @type {any}
     * @memberof SessionRequest
     */
    'notification_id'?: any;
}
/**
 * 
 * @export
 * @interface SessionResponse
 */
export interface SessionResponse {
    /**
     * 
     * @type {any}
     * @memberof SessionResponse
     */
    'id': any;
    /**
     * 
     * @type {any}
     * @memberof SessionResponse
     */
    'agent_id': any;
    /**
     * 
     * @type {any}
     * @memberof SessionResponse
     */
    'start_time'?: any;
    /**
     * 
     * @type {any}
     * @memberof SessionResponse
     */
    'title'?: any;
    /**
     * 
     * @type {any}
     * @memberof SessionResponse
     */
    'disclaimer'?: any;
}
/**
 * 
 * @export
 * @interface SimbaSource
 */
export interface SimbaSource {
    /**
     * 
     * @type {any}
     * @memberof SimbaSource
     */
    'content'?: any;
    /**
     * 
     * @type {any}
     * @memberof SimbaSource
     */
    'source_page'?: any;
}
/**
 * 
 * @export
 * @interface StateOrProvince
 */
export interface StateOrProvince {
}
/**
 * 
 * @export
 * @interface SupportFlowCallResponse
 */
export interface SupportFlowCallResponse {
    /**
     * 
     * @type {any}
     * @memberof SupportFlowCallResponse
     */
    'can_initiate'?: any;
    /**
     * 
     * @type {any}
     * @memberof SupportFlowCallResponse
     */
    'roar_items'?: any;
}
/**
 * 
 * @export
 * @interface SupportFlowDetails
 */
export interface SupportFlowDetails {
    /**
     * 
     * @type {any}
     * @memberof SupportFlowDetails
     */
    'ticket'?: any;
    /**
     * 
     * @type {any}
     * @memberof SupportFlowDetails
     */
    'call'?: any;
}
/**
 * 
 * @export
 * @interface SupportFlowRoarItem
 */
export interface SupportFlowRoarItem {
    /**
     * 
     * @type {any}
     * @memberof SupportFlowRoarItem
     */
    'office_group_id': any;
    /**
     * 
     * @type {any}
     * @memberof SupportFlowRoarItem
     */
    'office_group_name': any;
    /**
     * 
     * @type {RoarTargetGroupType}
     * @memberof SupportFlowRoarItem
     */
    'target_type'?: RoarTargetGroupType;
    /**
     * 
     * @type {any}
     * @memberof SupportFlowRoarItem
     */
    'container_id'?: any;
    /**
     * 
     * @type {RoarContainerType}
     * @memberof SupportFlowRoarItem
     */
    'container_type': RoarContainerType;
    /**
     * 
     * @type {any}
     * @memberof SupportFlowRoarItem
     */
    'agent_id': any;
}


/**
 * 
 * @export
 * @interface SupportFlowTicketResponse
 */
export interface SupportFlowTicketResponse {
    /**
     * 
     * @type {any}
     * @memberof SupportFlowTicketResponse
     */
    'can_create'?: any;
    /**
     * 
     * @type {any}
     * @memberof SupportFlowTicketResponse
     */
    'is_created'?: any;
    /**
     * 
     * @type {any}
     * @memberof SupportFlowTicketResponse
     */
    'ticket_url'?: any;
}
/**
 * 
 * @export
 * @interface SupportIntent
 */
export interface SupportIntent {
}
/**
 * 
 * @export
 * @interface TemplateItemDefinition
 */
export interface TemplateItemDefinition {
    /**
     * 
     * @type {any}
     * @memberof TemplateItemDefinition
     */
    'checklist_item_definition_id': any;
    /**
     * 
     * @type {any}
     * @memberof TemplateItemDefinition
     */
    'checklist_item_definition_name': any;
    /**
     * 
     * @type {any}
     * @memberof TemplateItemDefinition
     */
    'checklist_definition_name'?: any;
    /**
     * 
     * @type {any}
     * @memberof TemplateItemDefinition
     */
    'checklist_definition_id'?: any;
}
/**
 * 
 * @export
 * @interface TextSection
 */
export interface TextSection {
    /**
     * 
     * @type {any}
     * @memberof TextSection
     */
    'heading': any;
    /**
     * 
     * @type {any}
     * @memberof TextSection
     */
    'subtext': any;
}
/**
 * 
 * @export
 * @interface TopicResponse
 */
export interface TopicResponse {
    /**
     * 
     * @type {any}
     * @memberof TopicResponse
     */
    'items': any;
}
/**
 * 
 * @export
 * @interface USStateCode
 */
export interface USStateCode {
}
/**
 * 
 * @export
 * @interface UpdatePairRequest
 */
export interface UpdatePairRequest {
    /**
     * 
     * @type {any}
     * @memberof UpdatePairRequest
     */
    'start_date'?: any;
    /**
     * 
     * @type {any}
     * @memberof UpdatePairRequest
     */
    'end_date'?: any;
    /**
     * 
     * @type {any}
     * @memberof UpdatePairRequest
     */
    'is_enabled': any;
    /**
     * 
     * @type {any}
     * @memberof UpdatePairRequest
     */
    'assignee_id'?: any;
    /**
     * 
     * @type {any}
     * @memberof UpdatePairRequest
     */
    'question': any;
    /**
     * 
     * @type {any}
     * @memberof UpdatePairRequest
     */
    'answer'?: any;
    /**
     * 
     * @type {any}
     * @memberof UpdatePairRequest
     */
    'country'?: any;
    /**
     * 
     * @type {any}
     * @memberof UpdatePairRequest
     */
    'state_province'?: any;
    /**
     * 
     * @type {any}
     * @memberof UpdatePairRequest
     */
    'updated_by': any;
}
/**
 * 
 * @export
 * @interface UserIntentType
 */
export interface UserIntentType {
}
/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {any}
     * @memberof ValidationError
     */
    'loc': any;
    /**
     * 
     * @type {any}
     * @memberof ValidationError
     */
    'msg': any;
    /**
     * 
     * @type {any}
     * @memberof ValidationError
     */
    'type': any;
}
/**
 * 
 * @export
 * @interface VoteType
 */
export interface VoteType {
}
/**
 * 
 * @export
 * @interface ZendeskTicketResponse
 */
export interface ZendeskTicketResponse {
    /**
     * 
     * @type {any}
     * @memberof ZendeskTicketResponse
     */
    'id': any;
    /**
     * 
     * @type {any}
     * @memberof ZendeskTicketResponse
     */
    'url': any;
    /**
     * 
     * @type {any}
     * @memberof ZendeskTicketResponse
     */
    'subject'?: any;
    /**
     * 
     * @type {any}
     * @memberof ZendeskTicketResponse
     */
    'uploads'?: any;
}

/**
 * ChatApi - axios parameter creator
 * @export
 */
export const ChatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Captures user actions for the message
         * @param {any} messageId 
         * @param {MessageActionRequest} messageActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionChatMessageMessageIdActionPost: async (messageId: any, messageActionRequest: MessageActionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('actionChatMessageMessageIdActionPost', 'messageId', messageId)
            // verify required parameter 'messageActionRequest' is not null or undefined
            assertParamExists('actionChatMessageMessageIdActionPost', 'messageActionRequest', messageActionRequest)
            const localVarPath = `/chat/message/{message_id}/action`
                .replace(`{${"message_id"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(messageActionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate a stream of responses to a user\'s chat question.
         * @summary Chat Generate Stream
         * @param {any} sessionId 
         * @param {any} [question] 
         * @param {any} [saveToDb] 
         * @param {any} [modelName] 
         * @param {any} [notificationId] 
         * @param {any} [supportIntent] 
         * @param {any} [source] 
         * @param {any} [followUps] 
         * @param {any} [helperPrompt] 
         * @param {any} [rezenObjects] 
         * @param {BodyChatGenerateStreamChatGenerateStreamGet} [bodyChatGenerateStreamChatGenerateStreamGet] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatGenerateStreamChatGenerateStreamGet: async (sessionId: any, question?: any, saveToDb?: any, modelName?: any, notificationId?: any, supportIntent?: any, source?: any, followUps?: any, helperPrompt?: any, rezenObjects?: any, bodyChatGenerateStreamChatGenerateStreamGet?: BodyChatGenerateStreamChatGenerateStreamGet, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('chatGenerateStreamChatGenerateStreamGet', 'sessionId', sessionId)
            const localVarPath = `/chat/generate_stream`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (question !== undefined) {
                localVarQueryParameter['question'] = question;
            }

            if (sessionId !== undefined) {
                localVarQueryParameter['session_id'] = sessionId;
            }

            if (saveToDb !== undefined) {
                localVarQueryParameter['save_to_db'] = saveToDb;
            }

            if (modelName !== undefined) {
                localVarQueryParameter['model_name'] = modelName;
            }

            if (notificationId !== undefined) {
                localVarQueryParameter['notification_id'] = notificationId;
            }

            if (supportIntent !== undefined) {
                localVarQueryParameter['support_intent'] = supportIntent;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (followUps !== undefined) {
                localVarQueryParameter['follow_ups'] = followUps;
            }

            if (helperPrompt !== undefined) {
                localVarQueryParameter['helper_prompt'] = helperPrompt;
            }

            if (rezenObjects !== undefined) {
                localVarQueryParameter['rezen_objects'] = rezenObjects;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bodyChatGenerateStreamChatGenerateStreamGet, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new session in the database.
         * @summary Create Chat Session
         * @param {SessionRequest} sessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChatSessionChatSessionPost: async (sessionRequest: SessionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionRequest' is not null or undefined
            assertParamExists('createChatSessionChatSessionPost', 'sessionRequest', sessionRequest)
            const localVarPath = `/chat/session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sessionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Open a ticket for the message and session id passed
         * @summary Creates a zendesk ticket from the message
         * @param {any} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTicketChatMessageMessageIdTicketPost: async (messageId: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('createTicketChatMessageMessageIdTicketPost', 'messageId', messageId)
            const localVarPath = `/chat/message/{message_id}/ticket`
                .replace(`{${"message_id"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Session
         * @param {any} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSessionChatSessionSessionIdDelete: async (sessionId: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('deleteSessionChatSessionSessionIdDelete', 'sessionId', sessionId)
            const localVarPath = `/chat/session/{session_id}`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all chat sessions
         * @param {any} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAgentSessionsChatSessionGet: async (agentId: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('getAllAgentSessionsChatSessionGet', 'agentId', agentId)
            const localVarPath = `/chat/session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all chat sessions with pagination
         * @param {any} agentId 
         * @param {any} [page] Page number, defaults to 1.
         * @param {any} [limit] Size of a page, defaults to 10. Maximum is 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSessionsByAgentIdChatSessionsGet: async (agentId: any, page?: any, limit?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('getAllSessionsByAgentIdChatSessionsGet', 'agentId', agentId)
            const localVarPath = `/chat/sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get session messages
         * @param {any} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessagesChatMessagesGet: async (sessionId: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('getMessagesChatMessagesGet', 'sessionId', sessionId)
            const localVarPath = `/chat/messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sessionId !== undefined) {
                localVarQueryParameter['session_id'] = sessionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Prompt Suggestions
         * @param {PromptLibraryRequest} promptLibraryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromptSuggestionsChatPromptLibraryPost: async (promptLibraryRequest: PromptLibraryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'promptLibraryRequest' is not null or undefined
            assertParamExists('getPromptSuggestionsChatPromptLibraryPost', 'promptLibraryRequest', promptLibraryRequest)
            const localVarPath = `/chat/prompt-library`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(promptLibraryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the connection details for RTC (Real-Time Communication).
         * @summary Get Rtc Connection Details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRtcConnectionDetailsChatRtcConnectionDetailsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/chat/rtc/connection-details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Record a vote for a message.
         * @summary Vote a message
         * @param {any} messageId 
         * @param {VoteType} voteType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voteChatMessageMessageIdVoteVoteTypePost: async (messageId: any, voteType: VoteType, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('voteChatMessageMessageIdVoteVoteTypePost', 'messageId', messageId)
            // verify required parameter 'voteType' is not null or undefined
            assertParamExists('voteChatMessageMessageIdVoteVoteTypePost', 'voteType', voteType)
            const localVarPath = `/chat/message/{message_id}/vote/{vote_type}`
                .replace(`{${"message_id"}}`, encodeURIComponent(String(messageId)))
                .replace(`{${"vote_type"}}`, encodeURIComponent(String(voteType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatApi - functional programming interface
 * @export
 */
export const ChatApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Captures user actions for the message
         * @param {any} messageId 
         * @param {MessageActionRequest} messageActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actionChatMessageMessageIdActionPost(messageId: any, messageActionRequest: MessageActionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actionChatMessageMessageIdActionPost(messageId, messageActionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Generate a stream of responses to a user\'s chat question.
         * @summary Chat Generate Stream
         * @param {any} sessionId 
         * @param {any} [question] 
         * @param {any} [saveToDb] 
         * @param {any} [modelName] 
         * @param {any} [notificationId] 
         * @param {any} [supportIntent] 
         * @param {any} [source] 
         * @param {any} [followUps] 
         * @param {any} [helperPrompt] 
         * @param {any} [rezenObjects] 
         * @param {BodyChatGenerateStreamChatGenerateStreamGet} [bodyChatGenerateStreamChatGenerateStreamGet] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatGenerateStreamChatGenerateStreamGet(sessionId: any, question?: any, saveToDb?: any, modelName?: any, notificationId?: any, supportIntent?: any, source?: any, followUps?: any, helperPrompt?: any, rezenObjects?: any, bodyChatGenerateStreamChatGenerateStreamGet?: BodyChatGenerateStreamChatGenerateStreamGet, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatGenerateStreamChatGenerateStreamGet(sessionId, question, saveToDb, modelName, notificationId, supportIntent, source, followUps, helperPrompt, rezenObjects, bodyChatGenerateStreamChatGenerateStreamGet, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a new session in the database.
         * @summary Create Chat Session
         * @param {SessionRequest} sessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createChatSessionChatSessionPost(sessionRequest: SessionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createChatSessionChatSessionPost(sessionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Open a ticket for the message and session id passed
         * @summary Creates a zendesk ticket from the message
         * @param {any} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTicketChatMessageMessageIdTicketPost(messageId: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZendeskTicketResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTicketChatMessageMessageIdTicketPost(messageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete Session
         * @param {any} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSessionChatSessionSessionIdDelete(sessionId: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSessionChatSessionSessionIdDelete(sessionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all chat sessions
         * @param {any} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAgentSessionsChatSessionGet(agentId: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAgentSessionsChatSessionGet(agentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all chat sessions with pagination
         * @param {any} agentId 
         * @param {any} [page] Page number, defaults to 1.
         * @param {any} [limit] Size of a page, defaults to 10. Maximum is 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSessionsByAgentIdChatSessionsGet(agentId: any, page?: any, limit?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListResourceSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSessionsByAgentIdChatSessionsGet(agentId, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get session messages
         * @param {any} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMessagesChatMessagesGet(sessionId: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMessagesChatMessagesGet(sessionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Prompt Suggestions
         * @param {PromptLibraryRequest} promptLibraryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPromptSuggestionsChatPromptLibraryPost(promptLibraryRequest: PromptLibraryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromptLibraryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPromptSuggestionsChatPromptLibraryPost(promptLibraryRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the connection details for RTC (Real-Time Communication).
         * @summary Get Rtc Connection Details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRtcConnectionDetailsChatRtcConnectionDetailsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRtcConnectionDetailsChatRtcConnectionDetailsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Record a vote for a message.
         * @summary Vote a message
         * @param {any} messageId 
         * @param {VoteType} voteType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voteChatMessageMessageIdVoteVoteTypePost(messageId: any, voteType: VoteType, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Message>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voteChatMessageMessageIdVoteVoteTypePost(messageId, voteType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ChatApi - factory interface
 * @export
 */
export const ChatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatApiFp(configuration)
    return {
        /**
         * 
         * @summary Captures user actions for the message
         * @param {any} messageId 
         * @param {MessageActionRequest} messageActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionChatMessageMessageIdActionPost(messageId: any, messageActionRequest: MessageActionRequest, options?: any): AxiosPromise<any> {
            return localVarFp.actionChatMessageMessageIdActionPost(messageId, messageActionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate a stream of responses to a user\'s chat question.
         * @summary Chat Generate Stream
         * @param {any} sessionId 
         * @param {any} [question] 
         * @param {any} [saveToDb] 
         * @param {any} [modelName] 
         * @param {any} [notificationId] 
         * @param {any} [supportIntent] 
         * @param {any} [source] 
         * @param {any} [followUps] 
         * @param {any} [helperPrompt] 
         * @param {any} [rezenObjects] 
         * @param {BodyChatGenerateStreamChatGenerateStreamGet} [bodyChatGenerateStreamChatGenerateStreamGet] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatGenerateStreamChatGenerateStreamGet(sessionId: any, question?: any, saveToDb?: any, modelName?: any, notificationId?: any, supportIntent?: any, source?: any, followUps?: any, helperPrompt?: any, rezenObjects?: any, bodyChatGenerateStreamChatGenerateStreamGet?: BodyChatGenerateStreamChatGenerateStreamGet, options?: any): AxiosPromise<void> {
            return localVarFp.chatGenerateStreamChatGenerateStreamGet(sessionId, question, saveToDb, modelName, notificationId, supportIntent, source, followUps, helperPrompt, rezenObjects, bodyChatGenerateStreamChatGenerateStreamGet, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new session in the database.
         * @summary Create Chat Session
         * @param {SessionRequest} sessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChatSessionChatSessionPost(sessionRequest: SessionRequest, options?: any): AxiosPromise<SessionResponse> {
            return localVarFp.createChatSessionChatSessionPost(sessionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Open a ticket for the message and session id passed
         * @summary Creates a zendesk ticket from the message
         * @param {any} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTicketChatMessageMessageIdTicketPost(messageId: any, options?: any): AxiosPromise<ZendeskTicketResponse> {
            return localVarFp.createTicketChatMessageMessageIdTicketPost(messageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Session
         * @param {any} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSessionChatSessionSessionIdDelete(sessionId: any, options?: any): AxiosPromise<void> {
            return localVarFp.deleteSessionChatSessionSessionIdDelete(sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all chat sessions
         * @param {any} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAgentSessionsChatSessionGet(agentId: any, options?: any): AxiosPromise<any> {
            return localVarFp.getAllAgentSessionsChatSessionGet(agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all chat sessions with pagination
         * @param {any} agentId 
         * @param {any} [page] Page number, defaults to 1.
         * @param {any} [limit] Size of a page, defaults to 10. Maximum is 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSessionsByAgentIdChatSessionsGet(agentId: any, page?: any, limit?: any, options?: any): AxiosPromise<ListResourceSession> {
            return localVarFp.getAllSessionsByAgentIdChatSessionsGet(agentId, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get session messages
         * @param {any} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessagesChatMessagesGet(sessionId: any, options?: any): AxiosPromise<any> {
            return localVarFp.getMessagesChatMessagesGet(sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Prompt Suggestions
         * @param {PromptLibraryRequest} promptLibraryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromptSuggestionsChatPromptLibraryPost(promptLibraryRequest: PromptLibraryRequest, options?: any): AxiosPromise<PromptLibraryResponse> {
            return localVarFp.getPromptSuggestionsChatPromptLibraryPost(promptLibraryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the connection details for RTC (Real-Time Communication).
         * @summary Get Rtc Connection Details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRtcConnectionDetailsChatRtcConnectionDetailsGet(options?: any): AxiosPromise<any> {
            return localVarFp.getRtcConnectionDetailsChatRtcConnectionDetailsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Record a vote for a message.
         * @summary Vote a message
         * @param {any} messageId 
         * @param {VoteType} voteType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voteChatMessageMessageIdVoteVoteTypePost(messageId: any, voteType: VoteType, options?: any): AxiosPromise<Message> {
            return localVarFp.voteChatMessageMessageIdVoteVoteTypePost(messageId, voteType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChatApi - object-oriented interface
 * @export
 * @class ChatApi
 * @extends {BaseAPI}
 */
export class ChatApi extends BaseAPI {
    /**
     * 
     * @summary Captures user actions for the message
     * @param {any} messageId 
     * @param {MessageActionRequest} messageActionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public actionChatMessageMessageIdActionPost(messageId: any, messageActionRequest: MessageActionRequest, options?: AxiosRequestConfig) {
        return ChatApiFp(this.configuration).actionChatMessageMessageIdActionPost(messageId, messageActionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate a stream of responses to a user\'s chat question.
     * @summary Chat Generate Stream
     * @param {any} sessionId 
     * @param {any} [question] 
     * @param {any} [saveToDb] 
     * @param {any} [modelName] 
     * @param {any} [notificationId] 
     * @param {any} [supportIntent] 
     * @param {any} [source] 
     * @param {any} [followUps] 
     * @param {any} [helperPrompt] 
     * @param {any} [rezenObjects] 
     * @param {BodyChatGenerateStreamChatGenerateStreamGet} [bodyChatGenerateStreamChatGenerateStreamGet] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public chatGenerateStreamChatGenerateStreamGet(sessionId: any, question?: any, saveToDb?: any, modelName?: any, notificationId?: any, supportIntent?: any, source?: any, followUps?: any, helperPrompt?: any, rezenObjects?: any, bodyChatGenerateStreamChatGenerateStreamGet?: BodyChatGenerateStreamChatGenerateStreamGet, options?: AxiosRequestConfig) {
        return ChatApiFp(this.configuration).chatGenerateStreamChatGenerateStreamGet(sessionId, question, saveToDb, modelName, notificationId, supportIntent, source, followUps, helperPrompt, rezenObjects, bodyChatGenerateStreamChatGenerateStreamGet, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new session in the database.
     * @summary Create Chat Session
     * @param {SessionRequest} sessionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public createChatSessionChatSessionPost(sessionRequest: SessionRequest, options?: AxiosRequestConfig) {
        return ChatApiFp(this.configuration).createChatSessionChatSessionPost(sessionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Open a ticket for the message and session id passed
     * @summary Creates a zendesk ticket from the message
     * @param {any} messageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public createTicketChatMessageMessageIdTicketPost(messageId: any, options?: AxiosRequestConfig) {
        return ChatApiFp(this.configuration).createTicketChatMessageMessageIdTicketPost(messageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Session
     * @param {any} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public deleteSessionChatSessionSessionIdDelete(sessionId: any, options?: AxiosRequestConfig) {
        return ChatApiFp(this.configuration).deleteSessionChatSessionSessionIdDelete(sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all chat sessions
     * @param {any} agentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public getAllAgentSessionsChatSessionGet(agentId: any, options?: AxiosRequestConfig) {
        return ChatApiFp(this.configuration).getAllAgentSessionsChatSessionGet(agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all chat sessions with pagination
     * @param {any} agentId 
     * @param {any} [page] Page number, defaults to 1.
     * @param {any} [limit] Size of a page, defaults to 10. Maximum is 100.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public getAllSessionsByAgentIdChatSessionsGet(agentId: any, page?: any, limit?: any, options?: AxiosRequestConfig) {
        return ChatApiFp(this.configuration).getAllSessionsByAgentIdChatSessionsGet(agentId, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get session messages
     * @param {any} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public getMessagesChatMessagesGet(sessionId: any, options?: AxiosRequestConfig) {
        return ChatApiFp(this.configuration).getMessagesChatMessagesGet(sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Prompt Suggestions
     * @param {PromptLibraryRequest} promptLibraryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public getPromptSuggestionsChatPromptLibraryPost(promptLibraryRequest: PromptLibraryRequest, options?: AxiosRequestConfig) {
        return ChatApiFp(this.configuration).getPromptSuggestionsChatPromptLibraryPost(promptLibraryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the connection details for RTC (Real-Time Communication).
     * @summary Get Rtc Connection Details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public getRtcConnectionDetailsChatRtcConnectionDetailsGet(options?: AxiosRequestConfig) {
        return ChatApiFp(this.configuration).getRtcConnectionDetailsChatRtcConnectionDetailsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Record a vote for a message.
     * @summary Vote a message
     * @param {any} messageId 
     * @param {VoteType} voteType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public voteChatMessageMessageIdVoteVoteTypePost(messageId: any, voteType: VoteType, options?: AxiosRequestConfig) {
        return ChatApiFp(this.configuration).voteChatMessageMessageIdVoteVoteTypePost(messageId, voteType, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DocumentReviewApi - axios parameter creator
 * @export
 */
export const DocumentReviewApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Checklist Items Errors
         * @param {ChecklistItemErrorsRequest} checklistItemErrorsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistItemsErrorsDocumentReviewChecklistItemsErrorsPost: async (checklistItemErrorsRequest: ChecklistItemErrorsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checklistItemErrorsRequest' is not null or undefined
            assertParamExists('checklistItemsErrorsDocumentReviewChecklistItemsErrorsPost', 'checklistItemErrorsRequest', checklistItemErrorsRequest)
            const localVarPath = `/document-review/checklist-items/errors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checklistItemErrorsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a reaction to a checklist item
         * @param {any} reviewId 
         * @param {DocumentReviewReactionRequest} documentReviewReactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChecklistItemFeedbackDocumentReviewReviewIdReactionPost: async (reviewId: any, documentReviewReactionRequest: DocumentReviewReactionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reviewId' is not null or undefined
            assertParamExists('createChecklistItemFeedbackDocumentReviewReviewIdReactionPost', 'reviewId', reviewId)
            // verify required parameter 'documentReviewReactionRequest' is not null or undefined
            assertParamExists('createChecklistItemFeedbackDocumentReviewReviewIdReactionPost', 'documentReviewReactionRequest', documentReviewReactionRequest)
            const localVarPath = `/document-review/{review_id}/reaction`
                .replace(`{${"review_id"}}`, encodeURIComponent(String(reviewId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentReviewReactionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a template
         * @param {any} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTemplateDocumentReviewTemplatesTemplateIdDelete: async (templateId: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('deleteTemplateDocumentReviewTemplatesTemplateIdDelete', 'templateId', templateId)
            const localVarPath = `/document-review/templates/{template_id}`
                .replace(`{${"template_id"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Document Review
         * @param {any} reviewId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentReviewDocumentReviewReviewIdGet: async (reviewId: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reviewId' is not null or undefined
            assertParamExists('getDocumentReviewDocumentReviewReviewIdGet', 'reviewId', reviewId)
            const localVarPath = `/document-review/{review_id}`
                .replace(`{${"review_id"}}`, encodeURIComponent(String(reviewId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a template
         * @param {any} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateDocumentReviewTemplatesTemplateIdGet: async (templateId: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('getTemplateDocumentReviewTemplatesTemplateIdGet', 'templateId', templateId)
            const localVarPath = `/document-review/templates/{template_id}`
                .replace(`{${"template_id"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all configured templates
         * @param {any} [country] 
         * @param {any} [stateOrProvince] 
         * @param {any} [page] Page number, defaults to 1.
         * @param {any} [limit] Size of a page, defaults to 10. Maximum is 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplatesDocumentReviewTemplatesGet: async (country?: any, stateOrProvince?: any, page?: any, limit?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/document-review/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (stateOrProvince !== undefined) {
                localVarQueryParameter['state_or_province'] = stateOrProvince;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a template
         * @param {any} templateId 
         * @param {DocumentReviewTemplateUpdateRequest} documentReviewTemplateUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTemplateDocumentReviewTemplatesTemplateIdPatch: async (templateId: any, documentReviewTemplateUpdateRequest: DocumentReviewTemplateUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('updateTemplateDocumentReviewTemplatesTemplateIdPatch', 'templateId', templateId)
            // verify required parameter 'documentReviewTemplateUpdateRequest' is not null or undefined
            assertParamExists('updateTemplateDocumentReviewTemplatesTemplateIdPatch', 'documentReviewTemplateUpdateRequest', documentReviewTemplateUpdateRequest)
            const localVarPath = `/document-review/templates/{template_id}`
                .replace(`{${"template_id"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentReviewTemplateUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentReviewApi - functional programming interface
 * @export
 */
export const DocumentReviewApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentReviewApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Checklist Items Errors
         * @param {ChecklistItemErrorsRequest} checklistItemErrorsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checklistItemsErrorsDocumentReviewChecklistItemsErrorsPost(checklistItemErrorsRequest: ChecklistItemErrorsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChecklistItemErrorsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checklistItemsErrorsDocumentReviewChecklistItemsErrorsPost(checklistItemErrorsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a reaction to a checklist item
         * @param {any} reviewId 
         * @param {DocumentReviewReactionRequest} documentReviewReactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createChecklistItemFeedbackDocumentReviewReviewIdReactionPost(reviewId: any, documentReviewReactionRequest: DocumentReviewReactionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentReviewReactionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createChecklistItemFeedbackDocumentReviewReviewIdReactionPost(reviewId, documentReviewReactionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a template
         * @param {any} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTemplateDocumentReviewTemplatesTemplateIdDelete(templateId: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTemplateDocumentReviewTemplatesTemplateIdDelete(templateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Document Review
         * @param {any} reviewId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentReviewDocumentReviewReviewIdGet(reviewId: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentReviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentReviewDocumentReviewReviewIdGet(reviewId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a template
         * @param {any} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTemplateDocumentReviewTemplatesTemplateIdGet(templateId: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentReviewTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTemplateDocumentReviewTemplatesTemplateIdGet(templateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all configured templates
         * @param {any} [country] 
         * @param {any} [stateOrProvince] 
         * @param {any} [page] Page number, defaults to 1.
         * @param {any} [limit] Size of a page, defaults to 10. Maximum is 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTemplatesDocumentReviewTemplatesGet(country?: any, stateOrProvince?: any, page?: any, limit?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListResourceDocumentReviewTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTemplatesDocumentReviewTemplatesGet(country, stateOrProvince, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a template
         * @param {any} templateId 
         * @param {DocumentReviewTemplateUpdateRequest} documentReviewTemplateUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTemplateDocumentReviewTemplatesTemplateIdPatch(templateId: any, documentReviewTemplateUpdateRequest: DocumentReviewTemplateUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentReviewTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTemplateDocumentReviewTemplatesTemplateIdPatch(templateId, documentReviewTemplateUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DocumentReviewApi - factory interface
 * @export
 */
export const DocumentReviewApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentReviewApiFp(configuration)
    return {
        /**
         * 
         * @summary Checklist Items Errors
         * @param {ChecklistItemErrorsRequest} checklistItemErrorsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistItemsErrorsDocumentReviewChecklistItemsErrorsPost(checklistItemErrorsRequest: ChecklistItemErrorsRequest, options?: any): AxiosPromise<ChecklistItemErrorsResponse> {
            return localVarFp.checklistItemsErrorsDocumentReviewChecklistItemsErrorsPost(checklistItemErrorsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a reaction to a checklist item
         * @param {any} reviewId 
         * @param {DocumentReviewReactionRequest} documentReviewReactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChecklistItemFeedbackDocumentReviewReviewIdReactionPost(reviewId: any, documentReviewReactionRequest: DocumentReviewReactionRequest, options?: any): AxiosPromise<DocumentReviewReactionResponse> {
            return localVarFp.createChecklistItemFeedbackDocumentReviewReviewIdReactionPost(reviewId, documentReviewReactionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a template
         * @param {any} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTemplateDocumentReviewTemplatesTemplateIdDelete(templateId: any, options?: any): AxiosPromise<void> {
            return localVarFp.deleteTemplateDocumentReviewTemplatesTemplateIdDelete(templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Document Review
         * @param {any} reviewId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentReviewDocumentReviewReviewIdGet(reviewId: any, options?: any): AxiosPromise<DocumentReviewResponse> {
            return localVarFp.getDocumentReviewDocumentReviewReviewIdGet(reviewId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a template
         * @param {any} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateDocumentReviewTemplatesTemplateIdGet(templateId: any, options?: any): AxiosPromise<DocumentReviewTemplateResponse> {
            return localVarFp.getTemplateDocumentReviewTemplatesTemplateIdGet(templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all configured templates
         * @param {any} [country] 
         * @param {any} [stateOrProvince] 
         * @param {any} [page] Page number, defaults to 1.
         * @param {any} [limit] Size of a page, defaults to 10. Maximum is 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplatesDocumentReviewTemplatesGet(country?: any, stateOrProvince?: any, page?: any, limit?: any, options?: any): AxiosPromise<ListResourceDocumentReviewTemplateResponse> {
            return localVarFp.getTemplatesDocumentReviewTemplatesGet(country, stateOrProvince, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a template
         * @param {any} templateId 
         * @param {DocumentReviewTemplateUpdateRequest} documentReviewTemplateUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTemplateDocumentReviewTemplatesTemplateIdPatch(templateId: any, documentReviewTemplateUpdateRequest: DocumentReviewTemplateUpdateRequest, options?: any): AxiosPromise<DocumentReviewTemplateResponse> {
            return localVarFp.updateTemplateDocumentReviewTemplatesTemplateIdPatch(templateId, documentReviewTemplateUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentReviewApi - object-oriented interface
 * @export
 * @class DocumentReviewApi
 * @extends {BaseAPI}
 */
export class DocumentReviewApi extends BaseAPI {
    /**
     * 
     * @summary Checklist Items Errors
     * @param {ChecklistItemErrorsRequest} checklistItemErrorsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentReviewApi
     */
    public checklistItemsErrorsDocumentReviewChecklistItemsErrorsPost(checklistItemErrorsRequest: ChecklistItemErrorsRequest, options?: AxiosRequestConfig) {
        return DocumentReviewApiFp(this.configuration).checklistItemsErrorsDocumentReviewChecklistItemsErrorsPost(checklistItemErrorsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a reaction to a checklist item
     * @param {any} reviewId 
     * @param {DocumentReviewReactionRequest} documentReviewReactionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentReviewApi
     */
    public createChecklistItemFeedbackDocumentReviewReviewIdReactionPost(reviewId: any, documentReviewReactionRequest: DocumentReviewReactionRequest, options?: AxiosRequestConfig) {
        return DocumentReviewApiFp(this.configuration).createChecklistItemFeedbackDocumentReviewReviewIdReactionPost(reviewId, documentReviewReactionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a template
     * @param {any} templateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentReviewApi
     */
    public deleteTemplateDocumentReviewTemplatesTemplateIdDelete(templateId: any, options?: AxiosRequestConfig) {
        return DocumentReviewApiFp(this.configuration).deleteTemplateDocumentReviewTemplatesTemplateIdDelete(templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Document Review
     * @param {any} reviewId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentReviewApi
     */
    public getDocumentReviewDocumentReviewReviewIdGet(reviewId: any, options?: AxiosRequestConfig) {
        return DocumentReviewApiFp(this.configuration).getDocumentReviewDocumentReviewReviewIdGet(reviewId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a template
     * @param {any} templateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentReviewApi
     */
    public getTemplateDocumentReviewTemplatesTemplateIdGet(templateId: any, options?: AxiosRequestConfig) {
        return DocumentReviewApiFp(this.configuration).getTemplateDocumentReviewTemplatesTemplateIdGet(templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all configured templates
     * @param {any} [country] 
     * @param {any} [stateOrProvince] 
     * @param {any} [page] Page number, defaults to 1.
     * @param {any} [limit] Size of a page, defaults to 10. Maximum is 100.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentReviewApi
     */
    public getTemplatesDocumentReviewTemplatesGet(country?: any, stateOrProvince?: any, page?: any, limit?: any, options?: AxiosRequestConfig) {
        return DocumentReviewApiFp(this.configuration).getTemplatesDocumentReviewTemplatesGet(country, stateOrProvince, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a template
     * @param {any} templateId 
     * @param {DocumentReviewTemplateUpdateRequest} documentReviewTemplateUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentReviewApi
     */
    public updateTemplateDocumentReviewTemplatesTemplateIdPatch(templateId: any, documentReviewTemplateUpdateRequest: DocumentReviewTemplateUpdateRequest, options?: AxiosRequestConfig) {
        return DocumentReviewApiFp(this.configuration).updateTemplateDocumentReviewTemplatesTemplateIdPatch(templateId, documentReviewTemplateUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DownloadApi - axios parameter creator
 * @export
 */
export const DownloadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Download Poster
         * @param {any} imageUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPosterDownloadImageImageUrlGet: async (imageUrl: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageUrl' is not null or undefined
            assertParamExists('downloadPosterDownloadImageImageUrlGet', 'imageUrl', imageUrl)
            const localVarPath = `/download/image/{image_url}`
                .replace(`{${"image_url"}}`, encodeURIComponent(String(imageUrl)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DownloadApi - functional programming interface
 * @export
 */
export const DownloadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DownloadApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Download Poster
         * @param {any} imageUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadPosterDownloadImageImageUrlGet(imageUrl: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadPosterDownloadImageImageUrlGet(imageUrl, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DownloadApi - factory interface
 * @export
 */
export const DownloadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DownloadApiFp(configuration)
    return {
        /**
         * 
         * @summary Download Poster
         * @param {any} imageUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPosterDownloadImageImageUrlGet(imageUrl: any, options?: any): AxiosPromise<any> {
            return localVarFp.downloadPosterDownloadImageImageUrlGet(imageUrl, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DownloadApi - object-oriented interface
 * @export
 * @class DownloadApi
 * @extends {BaseAPI}
 */
export class DownloadApi extends BaseAPI {
    /**
     * 
     * @summary Download Poster
     * @param {any} imageUrl 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DownloadApi
     */
    public downloadPosterDownloadImageImageUrlGet(imageUrl: any, options?: AxiosRequestConfig) {
        return DownloadApiFp(this.configuration).downloadPosterDownloadImageImageUrlGet(imageUrl, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EmbeddingApi - axios parameter creator
 * @export
 */
export const EmbeddingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Inserts FAQ documents from Excel file into the database using Temporal workflow.  Args:     file: Excel file containing FAQ data     reindex: If true, delete all existing FAQs and re-index  Returns:     A dictionary containing the workflow status and ID.
         * @summary Ingest Faq Documents
         * @param {any} [reindex] 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ingestFaqDocumentsEmbeddingIngestFaqPost: async (reindex?: any, file?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/embedding/ingest_faq`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (reindex !== undefined) {
                localVarQueryParameter['reindex'] = reindex;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', new Blob([JSON.stringify(file)], { type: "application/json", }));
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Inserts courses documents into the database using Temporal workflow.  Returns:     A dictionary containing the workflow status and ID.
         * @summary Insert Courses Documents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertCoursesDocumentsEmbeddingIngestCoursesPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/embedding/ingest_courses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Inserts Sharran documents into the database using Temporal workflow.  Returns:     A dictionary containing the workflow status and ID.
         * @summary Insert Sharran Documents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertSharranDocumentsEmbeddingIngestSharranPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/embedding/ingest_sharran`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Inserts Widen assets into the database using Temporal workflow. Default asset type is: asset_type:(leoAsset:(Yes))  Args:     reindex: If true, delete all existing assets and re-index  Returns:     A dictionary containing the workflow status and ID.
         * @summary Insert Widen Assets
         * @param {any} [reindex] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertWidenAssetsEmbeddingIngestWidenAssetsPost: async (reindex?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/embedding/ingest_widen_assets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (reindex !== undefined) {
                localVarQueryParameter['reindex'] = reindex;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Inserts Zendesk documents into the database using Temporal workflow.  Args:     reindex: if true: delete all existing docs and re index
         * @summary Insert Zendesk Documents
         * @param {any} [reindex] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertZendeskDocumentsEmbeddingIngestZendeskPost: async (reindex?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/embedding/ingest_zendesk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (reindex !== undefined) {
                localVarQueryParameter['reindex'] = reindex;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload a csv file where the column named \"Reference\" will be embedded and all the other columns will be added as metadata
         * @summary Update Keywords
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateKeywordsEmbeddingIngestKeywordsPost: async (file?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/embedding/ingest_keywords`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', new Blob([JSON.stringify(file)], { type: "application/json", }));
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmbeddingApi - functional programming interface
 * @export
 */
export const EmbeddingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmbeddingApiAxiosParamCreator(configuration)
    return {
        /**
         * Inserts FAQ documents from Excel file into the database using Temporal workflow.  Args:     file: Excel file containing FAQ data     reindex: If true, delete all existing FAQs and re-index  Returns:     A dictionary containing the workflow status and ID.
         * @summary Ingest Faq Documents
         * @param {any} [reindex] 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ingestFaqDocumentsEmbeddingIngestFaqPost(reindex?: any, file?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ingestFaqDocumentsEmbeddingIngestFaqPost(reindex, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Inserts courses documents into the database using Temporal workflow.  Returns:     A dictionary containing the workflow status and ID.
         * @summary Insert Courses Documents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insertCoursesDocumentsEmbeddingIngestCoursesPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insertCoursesDocumentsEmbeddingIngestCoursesPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Inserts Sharran documents into the database using Temporal workflow.  Returns:     A dictionary containing the workflow status and ID.
         * @summary Insert Sharran Documents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insertSharranDocumentsEmbeddingIngestSharranPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insertSharranDocumentsEmbeddingIngestSharranPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Inserts Widen assets into the database using Temporal workflow. Default asset type is: asset_type:(leoAsset:(Yes))  Args:     reindex: If true, delete all existing assets and re-index  Returns:     A dictionary containing the workflow status and ID.
         * @summary Insert Widen Assets
         * @param {any} [reindex] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insertWidenAssetsEmbeddingIngestWidenAssetsPost(reindex?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insertWidenAssetsEmbeddingIngestWidenAssetsPost(reindex, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Inserts Zendesk documents into the database using Temporal workflow.  Args:     reindex: if true: delete all existing docs and re index
         * @summary Insert Zendesk Documents
         * @param {any} [reindex] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insertZendeskDocumentsEmbeddingIngestZendeskPost(reindex?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insertZendeskDocumentsEmbeddingIngestZendeskPost(reindex, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Upload a csv file where the column named \"Reference\" will be embedded and all the other columns will be added as metadata
         * @summary Update Keywords
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateKeywordsEmbeddingIngestKeywordsPost(file?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateKeywordsEmbeddingIngestKeywordsPost(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EmbeddingApi - factory interface
 * @export
 */
export const EmbeddingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmbeddingApiFp(configuration)
    return {
        /**
         * Inserts FAQ documents from Excel file into the database using Temporal workflow.  Args:     file: Excel file containing FAQ data     reindex: If true, delete all existing FAQs and re-index  Returns:     A dictionary containing the workflow status and ID.
         * @summary Ingest Faq Documents
         * @param {any} [reindex] 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ingestFaqDocumentsEmbeddingIngestFaqPost(reindex?: any, file?: any, options?: any): AxiosPromise<any> {
            return localVarFp.ingestFaqDocumentsEmbeddingIngestFaqPost(reindex, file, options).then((request) => request(axios, basePath));
        },
        /**
         * Inserts courses documents into the database using Temporal workflow.  Returns:     A dictionary containing the workflow status and ID.
         * @summary Insert Courses Documents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertCoursesDocumentsEmbeddingIngestCoursesPost(options?: any): AxiosPromise<any> {
            return localVarFp.insertCoursesDocumentsEmbeddingIngestCoursesPost(options).then((request) => request(axios, basePath));
        },
        /**
         * Inserts Sharran documents into the database using Temporal workflow.  Returns:     A dictionary containing the workflow status and ID.
         * @summary Insert Sharran Documents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertSharranDocumentsEmbeddingIngestSharranPost(options?: any): AxiosPromise<any> {
            return localVarFp.insertSharranDocumentsEmbeddingIngestSharranPost(options).then((request) => request(axios, basePath));
        },
        /**
         * Inserts Widen assets into the database using Temporal workflow. Default asset type is: asset_type:(leoAsset:(Yes))  Args:     reindex: If true, delete all existing assets and re-index  Returns:     A dictionary containing the workflow status and ID.
         * @summary Insert Widen Assets
         * @param {any} [reindex] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertWidenAssetsEmbeddingIngestWidenAssetsPost(reindex?: any, options?: any): AxiosPromise<any> {
            return localVarFp.insertWidenAssetsEmbeddingIngestWidenAssetsPost(reindex, options).then((request) => request(axios, basePath));
        },
        /**
         * Inserts Zendesk documents into the database using Temporal workflow.  Args:     reindex: if true: delete all existing docs and re index
         * @summary Insert Zendesk Documents
         * @param {any} [reindex] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertZendeskDocumentsEmbeddingIngestZendeskPost(reindex?: any, options?: any): AxiosPromise<any> {
            return localVarFp.insertZendeskDocumentsEmbeddingIngestZendeskPost(reindex, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload a csv file where the column named \"Reference\" will be embedded and all the other columns will be added as metadata
         * @summary Update Keywords
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateKeywordsEmbeddingIngestKeywordsPost(file?: any, options?: any): AxiosPromise<any> {
            return localVarFp.updateKeywordsEmbeddingIngestKeywordsPost(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmbeddingApi - object-oriented interface
 * @export
 * @class EmbeddingApi
 * @extends {BaseAPI}
 */
export class EmbeddingApi extends BaseAPI {
    /**
     * Inserts FAQ documents from Excel file into the database using Temporal workflow.  Args:     file: Excel file containing FAQ data     reindex: If true, delete all existing FAQs and re-index  Returns:     A dictionary containing the workflow status and ID.
     * @summary Ingest Faq Documents
     * @param {any} [reindex] 
     * @param {any} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmbeddingApi
     */
    public ingestFaqDocumentsEmbeddingIngestFaqPost(reindex?: any, file?: any, options?: AxiosRequestConfig) {
        return EmbeddingApiFp(this.configuration).ingestFaqDocumentsEmbeddingIngestFaqPost(reindex, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Inserts courses documents into the database using Temporal workflow.  Returns:     A dictionary containing the workflow status and ID.
     * @summary Insert Courses Documents
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmbeddingApi
     */
    public insertCoursesDocumentsEmbeddingIngestCoursesPost(options?: AxiosRequestConfig) {
        return EmbeddingApiFp(this.configuration).insertCoursesDocumentsEmbeddingIngestCoursesPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Inserts Sharran documents into the database using Temporal workflow.  Returns:     A dictionary containing the workflow status and ID.
     * @summary Insert Sharran Documents
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmbeddingApi
     */
    public insertSharranDocumentsEmbeddingIngestSharranPost(options?: AxiosRequestConfig) {
        return EmbeddingApiFp(this.configuration).insertSharranDocumentsEmbeddingIngestSharranPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Inserts Widen assets into the database using Temporal workflow. Default asset type is: asset_type:(leoAsset:(Yes))  Args:     reindex: If true, delete all existing assets and re-index  Returns:     A dictionary containing the workflow status and ID.
     * @summary Insert Widen Assets
     * @param {any} [reindex] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmbeddingApi
     */
    public insertWidenAssetsEmbeddingIngestWidenAssetsPost(reindex?: any, options?: AxiosRequestConfig) {
        return EmbeddingApiFp(this.configuration).insertWidenAssetsEmbeddingIngestWidenAssetsPost(reindex, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Inserts Zendesk documents into the database using Temporal workflow.  Args:     reindex: if true: delete all existing docs and re index
     * @summary Insert Zendesk Documents
     * @param {any} [reindex] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmbeddingApi
     */
    public insertZendeskDocumentsEmbeddingIngestZendeskPost(reindex?: any, options?: AxiosRequestConfig) {
        return EmbeddingApiFp(this.configuration).insertZendeskDocumentsEmbeddingIngestZendeskPost(reindex, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload a csv file where the column named \"Reference\" will be embedded and all the other columns will be added as metadata
     * @summary Update Keywords
     * @param {any} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmbeddingApi
     */
    public updateKeywordsEmbeddingIngestKeywordsPost(file?: any, options?: AxiosRequestConfig) {
        return EmbeddingApiFp(this.configuration).updateKeywordsEmbeddingIngestKeywordsPost(file, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LeoQuestionManagerApi - axios parameter creator
 * @export
 */
export const LeoQuestionManagerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Bulk update question answer pair
         * @summary Bulk Update
         * @param {BulkUpdateRequest} bulkUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateLqmQapairBulkPatch: async (bulkUpdateRequest: BulkUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkUpdateRequest' is not null or undefined
            assertParamExists('bulkUpdateLqmQapairBulkPatch', 'bulkUpdateRequest', bulkUpdateRequest)
            const localVarPath = `/lqm/qapair/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cluster Qa Pairs
         * @param {any} [topics] Pre-defined topics
         * @param {any} [page] Page number
         * @param {any} [pageSize] Number of records per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusterQaPairsLqmQapairClusterPairsGet: async (topics?: any, page?: any, pageSize?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/lqm/qapair/cluster_pairs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (topics !== undefined) {
                localVarQueryParameter['topics'] = topics;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create Embeddings for questions in the question manager table. Run once when the question_manager_embeddings table is empty. For incremental addition of questions in LQM, no need to run this, it will be taken care of in create_qa_pair API.
         * @summary Create Lqm Qmbeddings
         * @param {any} [page] Page number
         * @param {any} [pageSize] Number of records per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLqmQmbeddingsLqmQapairCreateLqmQmbeddingsGet: async (page?: any, pageSize?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/lqm/qapair/create_lqm_qmbeddings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new question answer pair
         * @summary Create Qa Pair
         * @param {PairRequest} pairRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQaPairLqmQapairPost: async (pairRequest: PairRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pairRequest' is not null or undefined
            assertParamExists('createQaPairLqmQapairPost', 'pairRequest', pairRequest)
            const localVarPath = `/lqm/qapair`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pairRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete existing question answer pair
         * @summary Delete Qa Pair
         * @param {any} pairId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQaPairLqmQapairPairIdDeletePatch: async (pairId: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pairId' is not null or undefined
            assertParamExists('deleteQaPairLqmQapairPairIdDeletePatch', 'pairId', pairId)
            const localVarPath = `/lqm/qapair/{pair_id}/delete`
                .replace(`{${"pair_id"}}`, encodeURIComponent(String(pairId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get UUIds of  experts
         * @summary Get Experts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpertsLqmQapairExpertsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/lqm/qapair/experts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get question answer pair queue ( Assigned, Completed, Work_queue)
         * @summary Get Queue
         * @param {any} isCompleted True if completed, False if assigned
         * @param {any} workQueue True if work queue, False if Assigned/Completed
         * @param {any} [page] Page number
         * @param {any} [limit] Number of records per page
         * @param {any} [start] Start date
         * @param {any} [end] End date
         * @param {any} [assigneeId] User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQueueLqmQapairQueueGet: async (isCompleted: any, workQueue: any, page?: any, limit?: any, start?: any, end?: any, assigneeId?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'isCompleted' is not null or undefined
            assertParamExists('getQueueLqmQapairQueueGet', 'isCompleted', isCompleted)
            // verify required parameter 'workQueue' is not null or undefined
            assertParamExists('getQueueLqmQapairQueueGet', 'workQueue', workQueue)
            const localVarPath = `/lqm/qapair/queue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isCompleted !== undefined) {
                localVarQueryParameter['is_completed'] = isCompleted;
            }

            if (workQueue !== undefined) {
                localVarQueryParameter['work_queue'] = workQueue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }

            if (assigneeId !== undefined) {
                localVarQueryParameter['assignee_id'] = assigneeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get question answer pair counts
         * @summary Get Total Counts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalCountsLqmQapairCountsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/lqm/qapair/counts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search question answer pairs based on keywords, queue and user
         * @summary Search
         * @param {any} isCompleted True if completed, False if assigned
         * @param {any} workQueue True if work queue, False if Assigned/Completed
         * @param {any} searchString Search terms, either multiple words or a phrase in double quotes
         * @param {any} [page] Page number
         * @param {any} [limit] Number of records per page
         * @param {any} [assigneeId] User ID
         * @param {any} [start] Start date
         * @param {any} [end] End date
         * @param {any} [country] Number of records to return
         * @param {any} [stateProvince] List of states/provinces
         * @param {any} [topics] List of topics
         * @param {any} [similarityParams] Similarity parameters as JSON string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchLqmQapairSearchGet: async (isCompleted: any, workQueue: any, searchString: any, page?: any, limit?: any, assigneeId?: any, start?: any, end?: any, country?: any, stateProvince?: any, topics?: any, similarityParams?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'isCompleted' is not null or undefined
            assertParamExists('searchLqmQapairSearchGet', 'isCompleted', isCompleted)
            // verify required parameter 'workQueue' is not null or undefined
            assertParamExists('searchLqmQapairSearchGet', 'workQueue', workQueue)
            // verify required parameter 'searchString' is not null or undefined
            assertParamExists('searchLqmQapairSearchGet', 'searchString', searchString)
            const localVarPath = `/lqm/qapair/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isCompleted !== undefined) {
                localVarQueryParameter['is_completed'] = isCompleted;
            }

            if (workQueue !== undefined) {
                localVarQueryParameter['work_queue'] = workQueue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['search_string'] = searchString;
            }

            if (assigneeId !== undefined) {
                localVarQueryParameter['assignee_id'] = assigneeId;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (stateProvince !== undefined) {
                localVarQueryParameter['state_province'] = stateProvince;
            }

            if (topics !== undefined) {
                localVarQueryParameter['topics'] = topics;
            }

            if (similarityParams !== undefined) {
                localVarQueryParameter['similarity_params'] = similarityParams;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Topics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        topicsLqmQapairTopicsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/lqm/qapair/topics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get question answer pair assignment
         * @summary Update Assignment
         * @param {any} pairId 
         * @param {any} [assigneeId] Assignee ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAssignmentLqmQapairPairIdAssignmentPatch: async (pairId: any, assigneeId?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pairId' is not null or undefined
            assertParamExists('updateAssignmentLqmQapairPairIdAssignmentPatch', 'pairId', pairId)
            const localVarPath = `/lqm/qapair/{pair_id}/assignment`
                .replace(`{${"pair_id"}}`, encodeURIComponent(String(pairId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (assigneeId !== undefined) {
                localVarQueryParameter['assignee_id'] = assigneeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update existing question answer pair
         * @summary Update Qa Pair
         * @param {any} pairId 
         * @param {UpdatePairRequest} updatePairRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQaPairLqmQapairPairIdPost: async (pairId: any, updatePairRequest: UpdatePairRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pairId' is not null or undefined
            assertParamExists('updateQaPairLqmQapairPairIdPost', 'pairId', pairId)
            // verify required parameter 'updatePairRequest' is not null or undefined
            assertParamExists('updateQaPairLqmQapairPairIdPost', 'updatePairRequest', updatePairRequest)
            const localVarPath = `/lqm/qapair/{pair_id}`
                .replace(`{${"pair_id"}}`, encodeURIComponent(String(pairId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePairRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LeoQuestionManagerApi - functional programming interface
 * @export
 */
export const LeoQuestionManagerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LeoQuestionManagerApiAxiosParamCreator(configuration)
    return {
        /**
         * Bulk update question answer pair
         * @summary Bulk Update
         * @param {BulkUpdateRequest} bulkUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUpdateLqmQapairBulkPatch(bulkUpdateRequest: BulkUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateLqmQapairBulkPatch(bulkUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Cluster Qa Pairs
         * @param {any} [topics] Pre-defined topics
         * @param {any} [page] Page number
         * @param {any} [pageSize] Number of records per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clusterQaPairsLqmQapairClusterPairsGet(topics?: any, page?: any, pageSize?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clusterQaPairsLqmQapairClusterPairsGet(topics, page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create Embeddings for questions in the question manager table. Run once when the question_manager_embeddings table is empty. For incremental addition of questions in LQM, no need to run this, it will be taken care of in create_qa_pair API.
         * @summary Create Lqm Qmbeddings
         * @param {any} [page] Page number
         * @param {any} [pageSize] Number of records per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLqmQmbeddingsLqmQapairCreateLqmQmbeddingsGet(page?: any, pageSize?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLqmQmbeddingsLqmQapairCreateLqmQmbeddingsGet(page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a new question answer pair
         * @summary Create Qa Pair
         * @param {PairRequest} pairRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createQaPairLqmQapairPost(pairRequest: PairRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createQaPairLqmQapairPost(pairRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete existing question answer pair
         * @summary Delete Qa Pair
         * @param {any} pairId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteQaPairLqmQapairPairIdDeletePatch(pairId: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteQaPairLqmQapairPairIdDeletePatch(pairId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get UUIds of  experts
         * @summary Get Experts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExpertsLqmQapairExpertsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExpertsLqmQapairExpertsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get question answer pair queue ( Assigned, Completed, Work_queue)
         * @summary Get Queue
         * @param {any} isCompleted True if completed, False if assigned
         * @param {any} workQueue True if work queue, False if Assigned/Completed
         * @param {any} [page] Page number
         * @param {any} [limit] Number of records per page
         * @param {any} [start] Start date
         * @param {any} [end] End date
         * @param {any} [assigneeId] User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQueueLqmQapairQueueGet(isCompleted: any, workQueue: any, page?: any, limit?: any, start?: any, end?: any, assigneeId?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedPairResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQueueLqmQapairQueueGet(isCompleted, workQueue, page, limit, start, end, assigneeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get question answer pair counts
         * @summary Get Total Counts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTotalCountsLqmQapairCountsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueueCountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTotalCountsLqmQapairCountsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Search question answer pairs based on keywords, queue and user
         * @summary Search
         * @param {any} isCompleted True if completed, False if assigned
         * @param {any} workQueue True if work queue, False if Assigned/Completed
         * @param {any} searchString Search terms, either multiple words or a phrase in double quotes
         * @param {any} [page] Page number
         * @param {any} [limit] Number of records per page
         * @param {any} [assigneeId] User ID
         * @param {any} [start] Start date
         * @param {any} [end] End date
         * @param {any} [country] Number of records to return
         * @param {any} [stateProvince] List of states/provinces
         * @param {any} [topics] List of topics
         * @param {any} [similarityParams] Similarity parameters as JSON string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchLqmQapairSearchGet(isCompleted: any, workQueue: any, searchString: any, page?: any, limit?: any, assigneeId?: any, start?: any, end?: any, country?: any, stateProvince?: any, topics?: any, similarityParams?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedPairResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchLqmQapairSearchGet(isCompleted, workQueue, searchString, page, limit, assigneeId, start, end, country, stateProvince, topics, similarityParams, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Topics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async topicsLqmQapairTopicsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TopicResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.topicsLqmQapairTopicsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get question answer pair assignment
         * @summary Update Assignment
         * @param {any} pairId 
         * @param {any} [assigneeId] Assignee ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAssignmentLqmQapairPairIdAssignmentPatch(pairId: any, assigneeId?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAssignmentLqmQapairPairIdAssignmentPatch(pairId, assigneeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update existing question answer pair
         * @summary Update Qa Pair
         * @param {any} pairId 
         * @param {UpdatePairRequest} updatePairRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateQaPairLqmQapairPairIdPost(pairId: any, updatePairRequest: UpdatePairRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateQaPairLqmQapairPairIdPost(pairId, updatePairRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LeoQuestionManagerApi - factory interface
 * @export
 */
export const LeoQuestionManagerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LeoQuestionManagerApiFp(configuration)
    return {
        /**
         * Bulk update question answer pair
         * @summary Bulk Update
         * @param {BulkUpdateRequest} bulkUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateLqmQapairBulkPatch(bulkUpdateRequest: BulkUpdateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.bulkUpdateLqmQapairBulkPatch(bulkUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cluster Qa Pairs
         * @param {any} [topics] Pre-defined topics
         * @param {any} [page] Page number
         * @param {any} [pageSize] Number of records per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusterQaPairsLqmQapairClusterPairsGet(topics?: any, page?: any, pageSize?: any, options?: any): AxiosPromise<any> {
            return localVarFp.clusterQaPairsLqmQapairClusterPairsGet(topics, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Create Embeddings for questions in the question manager table. Run once when the question_manager_embeddings table is empty. For incremental addition of questions in LQM, no need to run this, it will be taken care of in create_qa_pair API.
         * @summary Create Lqm Qmbeddings
         * @param {any} [page] Page number
         * @param {any} [pageSize] Number of records per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLqmQmbeddingsLqmQapairCreateLqmQmbeddingsGet(page?: any, pageSize?: any, options?: any): AxiosPromise<any> {
            return localVarFp.createLqmQmbeddingsLqmQapairCreateLqmQmbeddingsGet(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new question answer pair
         * @summary Create Qa Pair
         * @param {PairRequest} pairRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQaPairLqmQapairPost(pairRequest: PairRequest, options?: any): AxiosPromise<any> {
            return localVarFp.createQaPairLqmQapairPost(pairRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete existing question answer pair
         * @summary Delete Qa Pair
         * @param {any} pairId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQaPairLqmQapairPairIdDeletePatch(pairId: any, options?: any): AxiosPromise<void> {
            return localVarFp.deleteQaPairLqmQapairPairIdDeletePatch(pairId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get UUIds of  experts
         * @summary Get Experts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpertsLqmQapairExpertsGet(options?: any): AxiosPromise<any> {
            return localVarFp.getExpertsLqmQapairExpertsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get question answer pair queue ( Assigned, Completed, Work_queue)
         * @summary Get Queue
         * @param {any} isCompleted True if completed, False if assigned
         * @param {any} workQueue True if work queue, False if Assigned/Completed
         * @param {any} [page] Page number
         * @param {any} [limit] Number of records per page
         * @param {any} [start] Start date
         * @param {any} [end] End date
         * @param {any} [assigneeId] User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQueueLqmQapairQueueGet(isCompleted: any, workQueue: any, page?: any, limit?: any, start?: any, end?: any, assigneeId?: any, options?: any): AxiosPromise<PaginatedPairResponse> {
            return localVarFp.getQueueLqmQapairQueueGet(isCompleted, workQueue, page, limit, start, end, assigneeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get question answer pair counts
         * @summary Get Total Counts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalCountsLqmQapairCountsGet(options?: any): AxiosPromise<QueueCountResponse> {
            return localVarFp.getTotalCountsLqmQapairCountsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Search question answer pairs based on keywords, queue and user
         * @summary Search
         * @param {any} isCompleted True if completed, False if assigned
         * @param {any} workQueue True if work queue, False if Assigned/Completed
         * @param {any} searchString Search terms, either multiple words or a phrase in double quotes
         * @param {any} [page] Page number
         * @param {any} [limit] Number of records per page
         * @param {any} [assigneeId] User ID
         * @param {any} [start] Start date
         * @param {any} [end] End date
         * @param {any} [country] Number of records to return
         * @param {any} [stateProvince] List of states/provinces
         * @param {any} [topics] List of topics
         * @param {any} [similarityParams] Similarity parameters as JSON string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchLqmQapairSearchGet(isCompleted: any, workQueue: any, searchString: any, page?: any, limit?: any, assigneeId?: any, start?: any, end?: any, country?: any, stateProvince?: any, topics?: any, similarityParams?: any, options?: any): AxiosPromise<PaginatedPairResponse> {
            return localVarFp.searchLqmQapairSearchGet(isCompleted, workQueue, searchString, page, limit, assigneeId, start, end, country, stateProvince, topics, similarityParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Topics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        topicsLqmQapairTopicsGet(options?: any): AxiosPromise<TopicResponse> {
            return localVarFp.topicsLqmQapairTopicsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get question answer pair assignment
         * @summary Update Assignment
         * @param {any} pairId 
         * @param {any} [assigneeId] Assignee ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAssignmentLqmQapairPairIdAssignmentPatch(pairId: any, assigneeId?: any, options?: any): AxiosPromise<void> {
            return localVarFp.updateAssignmentLqmQapairPairIdAssignmentPatch(pairId, assigneeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update existing question answer pair
         * @summary Update Qa Pair
         * @param {any} pairId 
         * @param {UpdatePairRequest} updatePairRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQaPairLqmQapairPairIdPost(pairId: any, updatePairRequest: UpdatePairRequest, options?: any): AxiosPromise<any> {
            return localVarFp.updateQaPairLqmQapairPairIdPost(pairId, updatePairRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LeoQuestionManagerApi - object-oriented interface
 * @export
 * @class LeoQuestionManagerApi
 * @extends {BaseAPI}
 */
export class LeoQuestionManagerApi extends BaseAPI {
    /**
     * Bulk update question answer pair
     * @summary Bulk Update
     * @param {BulkUpdateRequest} bulkUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeoQuestionManagerApi
     */
    public bulkUpdateLqmQapairBulkPatch(bulkUpdateRequest: BulkUpdateRequest, options?: AxiosRequestConfig) {
        return LeoQuestionManagerApiFp(this.configuration).bulkUpdateLqmQapairBulkPatch(bulkUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cluster Qa Pairs
     * @param {any} [topics] Pre-defined topics
     * @param {any} [page] Page number
     * @param {any} [pageSize] Number of records per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeoQuestionManagerApi
     */
    public clusterQaPairsLqmQapairClusterPairsGet(topics?: any, page?: any, pageSize?: any, options?: AxiosRequestConfig) {
        return LeoQuestionManagerApiFp(this.configuration).clusterQaPairsLqmQapairClusterPairsGet(topics, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create Embeddings for questions in the question manager table. Run once when the question_manager_embeddings table is empty. For incremental addition of questions in LQM, no need to run this, it will be taken care of in create_qa_pair API.
     * @summary Create Lqm Qmbeddings
     * @param {any} [page] Page number
     * @param {any} [pageSize] Number of records per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeoQuestionManagerApi
     */
    public createLqmQmbeddingsLqmQapairCreateLqmQmbeddingsGet(page?: any, pageSize?: any, options?: AxiosRequestConfig) {
        return LeoQuestionManagerApiFp(this.configuration).createLqmQmbeddingsLqmQapairCreateLqmQmbeddingsGet(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new question answer pair
     * @summary Create Qa Pair
     * @param {PairRequest} pairRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeoQuestionManagerApi
     */
    public createQaPairLqmQapairPost(pairRequest: PairRequest, options?: AxiosRequestConfig) {
        return LeoQuestionManagerApiFp(this.configuration).createQaPairLqmQapairPost(pairRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete existing question answer pair
     * @summary Delete Qa Pair
     * @param {any} pairId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeoQuestionManagerApi
     */
    public deleteQaPairLqmQapairPairIdDeletePatch(pairId: any, options?: AxiosRequestConfig) {
        return LeoQuestionManagerApiFp(this.configuration).deleteQaPairLqmQapairPairIdDeletePatch(pairId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get UUIds of  experts
     * @summary Get Experts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeoQuestionManagerApi
     */
    public getExpertsLqmQapairExpertsGet(options?: AxiosRequestConfig) {
        return LeoQuestionManagerApiFp(this.configuration).getExpertsLqmQapairExpertsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get question answer pair queue ( Assigned, Completed, Work_queue)
     * @summary Get Queue
     * @param {any} isCompleted True if completed, False if assigned
     * @param {any} workQueue True if work queue, False if Assigned/Completed
     * @param {any} [page] Page number
     * @param {any} [limit] Number of records per page
     * @param {any} [start] Start date
     * @param {any} [end] End date
     * @param {any} [assigneeId] User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeoQuestionManagerApi
     */
    public getQueueLqmQapairQueueGet(isCompleted: any, workQueue: any, page?: any, limit?: any, start?: any, end?: any, assigneeId?: any, options?: AxiosRequestConfig) {
        return LeoQuestionManagerApiFp(this.configuration).getQueueLqmQapairQueueGet(isCompleted, workQueue, page, limit, start, end, assigneeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get question answer pair counts
     * @summary Get Total Counts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeoQuestionManagerApi
     */
    public getTotalCountsLqmQapairCountsGet(options?: AxiosRequestConfig) {
        return LeoQuestionManagerApiFp(this.configuration).getTotalCountsLqmQapairCountsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search question answer pairs based on keywords, queue and user
     * @summary Search
     * @param {any} isCompleted True if completed, False if assigned
     * @param {any} workQueue True if work queue, False if Assigned/Completed
     * @param {any} searchString Search terms, either multiple words or a phrase in double quotes
     * @param {any} [page] Page number
     * @param {any} [limit] Number of records per page
     * @param {any} [assigneeId] User ID
     * @param {any} [start] Start date
     * @param {any} [end] End date
     * @param {any} [country] Number of records to return
     * @param {any} [stateProvince] List of states/provinces
     * @param {any} [topics] List of topics
     * @param {any} [similarityParams] Similarity parameters as JSON string
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeoQuestionManagerApi
     */
    public searchLqmQapairSearchGet(isCompleted: any, workQueue: any, searchString: any, page?: any, limit?: any, assigneeId?: any, start?: any, end?: any, country?: any, stateProvince?: any, topics?: any, similarityParams?: any, options?: AxiosRequestConfig) {
        return LeoQuestionManagerApiFp(this.configuration).searchLqmQapairSearchGet(isCompleted, workQueue, searchString, page, limit, assigneeId, start, end, country, stateProvince, topics, similarityParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Topics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeoQuestionManagerApi
     */
    public topicsLqmQapairTopicsGet(options?: AxiosRequestConfig) {
        return LeoQuestionManagerApiFp(this.configuration).topicsLqmQapairTopicsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get question answer pair assignment
     * @summary Update Assignment
     * @param {any} pairId 
     * @param {any} [assigneeId] Assignee ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeoQuestionManagerApi
     */
    public updateAssignmentLqmQapairPairIdAssignmentPatch(pairId: any, assigneeId?: any, options?: AxiosRequestConfig) {
        return LeoQuestionManagerApiFp(this.configuration).updateAssignmentLqmQapairPairIdAssignmentPatch(pairId, assigneeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update existing question answer pair
     * @summary Update Qa Pair
     * @param {any} pairId 
     * @param {UpdatePairRequest} updatePairRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeoQuestionManagerApi
     */
    public updateQaPairLqmQapairPairIdPost(pairId: any, updatePairRequest: UpdatePairRequest, options?: AxiosRequestConfig) {
        return LeoQuestionManagerApiFp(this.configuration).updateQaPairLqmQapairPairIdPost(pairId, updatePairRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MaterialReviewsApi - axios parameter creator
 * @export
 */
export const MaterialReviewsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create
         * @param {MaterialReviewRequest} materialReviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMaterialReviewsPost: async (materialReviewRequest: MaterialReviewRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'materialReviewRequest' is not null or undefined
            assertParamExists('createMaterialReviewsPost', 'materialReviewRequest', materialReviewRequest)
            const localVarPath = `/material-reviews/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(materialReviewRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MaterialReviewsApi - functional programming interface
 * @export
 */
export const MaterialReviewsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MaterialReviewsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create
         * @param {MaterialReviewRequest} materialReviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMaterialReviewsPost(materialReviewRequest: MaterialReviewRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MaterialReviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMaterialReviewsPost(materialReviewRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MaterialReviewsApi - factory interface
 * @export
 */
export const MaterialReviewsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MaterialReviewsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create
         * @param {MaterialReviewRequest} materialReviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMaterialReviewsPost(materialReviewRequest: MaterialReviewRequest, options?: any): AxiosPromise<MaterialReviewResponse> {
            return localVarFp.createMaterialReviewsPost(materialReviewRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MaterialReviewsApi - object-oriented interface
 * @export
 * @class MaterialReviewsApi
 * @extends {BaseAPI}
 */
export class MaterialReviewsApi extends BaseAPI {
    /**
     * 
     * @summary Create
     * @param {MaterialReviewRequest} materialReviewRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaterialReviewsApi
     */
    public createMaterialReviewsPost(materialReviewRequest: MaterialReviewRequest, options?: AxiosRequestConfig) {
        return MaterialReviewsApiFp(this.configuration).createMaterialReviewsPost(materialReviewRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * NotificationsApi - axios parameter creator
 * @export
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Action
         * @param {any} notificationId 
         * @param {NotificationActionRequest} notificationActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionNotificationsNotificationIdActionPost: async (notificationId: any, notificationActionRequest: NotificationActionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('actionNotificationsNotificationIdActionPost', 'notificationId', notificationId)
            // verify required parameter 'notificationActionRequest' is not null or undefined
            assertParamExists('actionNotificationsNotificationIdActionPost', 'notificationActionRequest', notificationActionRequest)
            const localVarPath = `/notifications/{notification_id}/action`
                .replace(`{${"notification_id"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationActionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Dismiss
         * @param {any} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissNotificationsNotificationIdDismissPost: async (notificationId: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('dismissNotificationsNotificationIdDismissPost', 'notificationId', notificationId)
            const localVarPath = `/notifications/{notification_id}/dismiss`
                .replace(`{${"notification_id"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Notification
         * @param {any} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationNotificationsNotificationIdGet: async (notificationId: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('getNotificationNotificationsNotificationIdGet', 'notificationId', notificationId)
            const localVarPath = `/notifications/{notification_id}`
                .replace(`{${"notification_id"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Notifications
         * @param {any} [page] Page number, defaults to 1.
         * @param {any} [limit] Size of a page, defaults to 10. Maximum is 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotificationsNotificationsGet: async (page?: any, limit?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notifications/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Record Notification Event
         * @param {any} notificationId 
         * @param {NotificationEventRequest} notificationEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordNotificationEventNotificationsNotificationIdEventsPost: async (notificationId: any, notificationEventRequest: NotificationEventRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('recordNotificationEventNotificationsNotificationIdEventsPost', 'notificationId', notificationId)
            // verify required parameter 'notificationEventRequest' is not null or undefined
            assertParamExists('recordNotificationEventNotificationsNotificationIdEventsPost', 'notificationEventRequest', notificationEventRequest)
            const localVarPath = `/notifications/{notification_id}/events`
                .replace(`{${"notification_id"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationEventRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 * @export
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Action
         * @param {any} notificationId 
         * @param {NotificationActionRequest} notificationActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actionNotificationsNotificationIdActionPost(notificationId: any, notificationActionRequest: NotificationActionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actionNotificationsNotificationIdActionPost(notificationId, notificationActionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Dismiss
         * @param {any} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dismissNotificationsNotificationIdDismissPost(notificationId: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dismissNotificationsNotificationIdDismissPost(notificationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Notification
         * @param {any} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificationNotificationsNotificationIdGet(notificationId: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotificationNotificationsNotificationIdGet(notificationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List Notifications
         * @param {any} [page] Page number, defaults to 1.
         * @param {any} [limit] Size of a page, defaults to 10. Maximum is 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listNotificationsNotificationsGet(page?: any, limit?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListResourceNotificationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listNotificationsNotificationsGet(page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Record Notification Event
         * @param {any} notificationId 
         * @param {NotificationEventRequest} notificationEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recordNotificationEventNotificationsNotificationIdEventsPost(notificationId: any, notificationEventRequest: NotificationEventRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recordNotificationEventNotificationsNotificationIdEventsPost(notificationId, notificationEventRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NotificationsApi - factory interface
 * @export
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Action
         * @param {any} notificationId 
         * @param {NotificationActionRequest} notificationActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionNotificationsNotificationIdActionPost(notificationId: any, notificationActionRequest: NotificationActionRequest, options?: any): AxiosPromise<any> {
            return localVarFp.actionNotificationsNotificationIdActionPost(notificationId, notificationActionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Dismiss
         * @param {any} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissNotificationsNotificationIdDismissPost(notificationId: any, options?: any): AxiosPromise<void> {
            return localVarFp.dismissNotificationsNotificationIdDismissPost(notificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Notification
         * @param {any} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationNotificationsNotificationIdGet(notificationId: any, options?: any): AxiosPromise<NotificationResponse> {
            return localVarFp.getNotificationNotificationsNotificationIdGet(notificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Notifications
         * @param {any} [page] Page number, defaults to 1.
         * @param {any} [limit] Size of a page, defaults to 10. Maximum is 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotificationsNotificationsGet(page?: any, limit?: any, options?: any): AxiosPromise<ListResourceNotificationResponse> {
            return localVarFp.listNotificationsNotificationsGet(page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Record Notification Event
         * @param {any} notificationId 
         * @param {NotificationEventRequest} notificationEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordNotificationEventNotificationsNotificationIdEventsPost(notificationId: any, notificationEventRequest: NotificationEventRequest, options?: any): AxiosPromise<void> {
            return localVarFp.recordNotificationEventNotificationsNotificationIdEventsPost(notificationId, notificationEventRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationsApi - object-oriented interface
 * @export
 * @class NotificationsApi
 * @extends {BaseAPI}
 */
export class NotificationsApi extends BaseAPI {
    /**
     * 
     * @summary Action
     * @param {any} notificationId 
     * @param {NotificationActionRequest} notificationActionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public actionNotificationsNotificationIdActionPost(notificationId: any, notificationActionRequest: NotificationActionRequest, options?: AxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).actionNotificationsNotificationIdActionPost(notificationId, notificationActionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Dismiss
     * @param {any} notificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public dismissNotificationsNotificationIdDismissPost(notificationId: any, options?: AxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).dismissNotificationsNotificationIdDismissPost(notificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Notification
     * @param {any} notificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public getNotificationNotificationsNotificationIdGet(notificationId: any, options?: AxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getNotificationNotificationsNotificationIdGet(notificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Notifications
     * @param {any} [page] Page number, defaults to 1.
     * @param {any} [limit] Size of a page, defaults to 10. Maximum is 100.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public listNotificationsNotificationsGet(page?: any, limit?: any, options?: AxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).listNotificationsNotificationsGet(page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Record Notification Event
     * @param {any} notificationId 
     * @param {NotificationEventRequest} notificationEventRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public recordNotificationEventNotificationsNotificationIdEventsPost(notificationId: any, notificationEventRequest: NotificationEventRequest, options?: AxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).recordNotificationEventNotificationsNotificationIdEventsPost(notificationId, notificationEventRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SearchApi - axios parameter creator
 * @export
 */
export const SearchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Action
         * @param {SearchActionRequest} searchActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActionSearchActionPost: async (searchActionRequest: SearchActionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchActionRequest' is not null or undefined
            assertParamExists('createActionSearchActionPost', 'searchActionRequest', searchActionRequest)
            const localVarPath = `/search/action`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchActionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search
         * @param {any} [q] 
         * @param {any} [source] 
         * @param {any} [page] Page number, defaults to 1.
         * @param {any} [limit] Size of a page, defaults to 10. Maximum is 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSearchGet: async (q?: any, source?: any, page?: any, limit?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/search/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SearchApi - functional programming interface
 * @export
 */
export const SearchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SearchApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Action
         * @param {SearchActionRequest} searchActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createActionSearchActionPost(searchActionRequest: SearchActionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createActionSearchActionPost(searchActionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search
         * @param {any} [q] 
         * @param {any} [source] 
         * @param {any} [page] Page number, defaults to 1.
         * @param {any} [limit] Size of a page, defaults to 10. Maximum is 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchSearchGet(q?: any, source?: any, page?: any, limit?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchSearchGet(q, source, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SearchApi - factory interface
 * @export
 */
export const SearchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SearchApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Action
         * @param {SearchActionRequest} searchActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActionSearchActionPost(searchActionRequest: SearchActionRequest, options?: any): AxiosPromise<any> {
            return localVarFp.createActionSearchActionPost(searchActionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search
         * @param {any} [q] 
         * @param {any} [source] 
         * @param {any} [page] Page number, defaults to 1.
         * @param {any} [limit] Size of a page, defaults to 10. Maximum is 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSearchGet(q?: any, source?: any, page?: any, limit?: any, options?: any): AxiosPromise<SearchResponse> {
            return localVarFp.searchSearchGet(q, source, page, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SearchApi - object-oriented interface
 * @export
 * @class SearchApi
 * @extends {BaseAPI}
 */
export class SearchApi extends BaseAPI {
    /**
     * 
     * @summary Create Action
     * @param {SearchActionRequest} searchActionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    public createActionSearchActionPost(searchActionRequest: SearchActionRequest, options?: AxiosRequestConfig) {
        return SearchApiFp(this.configuration).createActionSearchActionPost(searchActionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search
     * @param {any} [q] 
     * @param {any} [source] 
     * @param {any} [page] Page number, defaults to 1.
     * @param {any} [limit] Size of a page, defaults to 10. Maximum is 100.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    public searchSearchGet(q?: any, source?: any, page?: any, limit?: any, options?: AxiosRequestConfig) {
        return SearchApiFp(this.configuration).searchSearchGet(q, source, page, limit, options).then((request) => request(this.axios, this.basePath));
    }
}


